
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AchievementScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  companyGlobalId: 'companyGlobalId',
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  issueYear: 'issueYear',
  description: 'description',
  searchDescription: 'searchDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ActivityLogScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  candidateApplicationId: 'candidateApplicationId',
  activityTimestamp: 'activityTimestamp',
  activity: 'activity',
  companyUserId: 'companyUserId',
  userAction: 'userAction',
  jobAction: 'jobAction',
  templateStageId: 'templateStageId',
  previousTemplateStageId: 'previousTemplateStageId',
  userIp: 'userIp',
  requisitionId: 'requisitionId',
  companyId: 'companyId',
  jobOpeningId: 'jobOpeningId',
  candidateOfferVersionId: 'candidateOfferVersionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  approvalWorkflowVersionId: 'approvalWorkflowVersionId'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  contactName: 'contactName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  timeZone: 'timeZone',
  longitude: 'longitude',
  latitude: 'latitude',
  companyId: 'companyId',
  jobListingId: 'jobListingId',
  officeId: 'officeId',
  addressType: 'addressType',
  activeStatus: 'activeStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApplicantNotesScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  scalisUserId: 'scalisUserId',
  userNoteId: 'userNoteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApplicationRejectionScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  reason: 'reason',
  details: 'details',
  messageId: 'messageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApplicationSnapshotScalarFieldEnum = {
  id: 'id',
  candidateApplication: 'candidateApplication',
  snapshotData: 'snapshotData',
  createdAt: 'createdAt'
};

exports.Prisma.ArchivedChatScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  scalisUserId: 'scalisUserId',
  chatId: 'chatId',
  archivedAt: 'archivedAt'
};

exports.Prisma.BookmarkedJobScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  jobListingId: 'jobListingId',
  publicListingId: 'publicListingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateApplicationScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  applicationType: 'applicationType',
  applicationStatus: 'applicationStatus',
  jobListingId: 'jobListingId',
  templateStageId: 'templateStageId',
  applicationTimestamp: 'applicationTimestamp',
  companyId: 'companyId',
  viewedProfile: 'viewedProfile',
  matchScore: 'matchScore',
  lastUpdatedStatusAt: 'lastUpdatedStatusAt',
  applicationCreationType: 'applicationCreationType',
  interviewScheduling: 'interviewScheduling',
  viewedAt: 'viewedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appliedAt: 'appliedAt',
  deleted: 'deleted',
  duplicationStatus: 'duplicationStatus',
  customApplicationStatusId: 'customApplicationStatusId'
};

exports.Prisma.CandidateApplicationNoteScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  privateStatus: 'privateStatus',
  companyUserId: 'companyUserId',
  companyId: 'companyId',
  userNoteId: 'userNoteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateApplicationRatingScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  candidateProfileId: 'candidateProfileId',
  companyUserId: 'companyUserId',
  score: 'score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateInterviewScalarFieldEnum = {
  id: 'id',
  applicationId: 'applicationId',
  stageId: 'stageId',
  integrationsNylasNotetakerId: 'integrationsNylasNotetakerId',
  interviewData: 'interviewData',
  status: 'status',
  interviewTemplateId: 'interviewTemplateId',
  interviewerPoolId: 'interviewerPoolId',
  interviewStatus: 'interviewStatus',
  schedulingLogic: 'schedulingLogic',
  duration: 'duration',
  debriefScheduled: 'debriefScheduled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  candidateInterviewLoopId: 'candidateInterviewLoopId'
};

exports.Prisma.CandidateInterviewCompanyUserScalarFieldEnum = {
  id: 'id',
  candidateInterviewId: 'candidateInterviewId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isOrganizer: 'isOrganizer'
};

exports.Prisma.CandidateMedalistDesignationScalarFieldEnum = {
  id: 'id',
  profileDetailsId: 'profileDetailsId',
  medalistDesignation: 'medalistDesignation',
  jobListingId: 'jobListingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateMessageScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  companyUserId: 'companyUserId',
  customMessage: 'customMessage',
  templateMessageId: 'templateMessageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateProfileScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  companyId: 'companyId',
  scalisUserId: 'scalisUserId',
  primaryEmail: 'primaryEmail',
  doNotContact: 'doNotContact',
  profileType: 'profileType',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateProfileLocationScalarFieldEnum = {
  id: 'id',
  profileDetailsId: 'profileDetailsId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateProfileNoteScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  privateStatus: 'privateStatus',
  companyUserId: 'companyUserId',
  companyId: 'companyId',
  userNoteId: 'userNoteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateScorecardScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  scorecardTemplateId: 'scorecardTemplateId',
  companyUserId: 'companyUserId',
  additionalInformation: 'additionalInformation',
  templateStageId: 'templateStageId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateScorecardAnswersScalarFieldEnum = {
  id: 'id',
  candidateScorecardId: 'candidateScorecardId',
  scorecardTemplateQuestionId: 'scorecardTemplateQuestionId',
  answer: 'answer',
  answerPreferredStatus: 'answerPreferredStatus',
  scoreAnswer: 'scoreAnswer',
  overallRecommendation: 'overallRecommendation',
  dateAnswer: 'dateAnswer',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateSourceScalarFieldEnum = {
  id: 'id',
  profileDetailsId: 'profileDetailsId',
  sourceNameId: 'sourceNameId',
  sourceStrategy: 'sourceStrategy',
  creditCompanyUserId: 'creditCompanyUserId',
  creditExternal: 'creditExternal',
  candidateApplicationId: 'candidateApplicationId',
  jobListingId: 'jobListingId',
  campaignId: 'campaignId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateSourceNameScalarFieldEnum = {
  id: 'id',
  sourceCategory: 'sourceCategory',
  name: 'name',
  companyId: 'companyId',
  customSourceCategoryId: 'customSourceCategoryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomSourceCategoryScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  sourceCategoryName: 'sourceCategoryName',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CertificateOrLicenseScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  companyGlobalId: 'companyGlobalId',
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  issueYear: 'issueYear',
  description: 'description',
  searchDescription: 'searchDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatScalarFieldEnum = {
  id: 'id',
  channelName: 'channelName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatParticipantScalarFieldEnum = {
  chatId: 'chatId',
  userId: 'userId',
  joinedAt: 'joinedAt'
};

exports.Prisma.ChatC2JScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  coUser: 'coUser',
  scUser: 'scUser',
  companyId: 'companyId',
  chatId: 'chatId'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastActivity: 'lastActivity',
  externalId: 'externalId',
  subdomain: 'subdomain',
  paymentGatewayCustomerId: 'paymentGatewayCustomerId',
  currency: 'currency',
  linkedinId: 'linkedinId'
};

exports.Prisma.CompanyDepartmentScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  departmentName: 'departmentName',
  subordinateTo: 'subordinateTo',
  externalId: 'externalId',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyInfoScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyName: 'companyName',
  logo: 'logo',
  companyType: 'companyType',
  recruitingOrStaffing: 'recruitingOrStaffing',
  industry: 'industry',
  subIndustry: 'subIndustry',
  phoneNumber: 'phoneNumber',
  website: 'website',
  yearsInOperation: 'yearsInOperation',
  employeeCount: 'employeeCount',
  positionsToFill: 'positionsToFill',
  hiringNeeds: 'hiringNeeds',
  atsNeeds: 'atsNeeds',
  usingATS: 'usingATS',
  currentAtsName: 'currentAtsName',
  reasonToSwitch: 'reasonToSwitch',
  linkedin: 'linkedin',
  linkedinId: 'linkedinId',
  hearAboutUs: 'hearAboutUs',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyOfficeScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  officeName: 'officeName',
  externalId: 'externalId',
  addressId: 'addressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyUserScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  userInvitationId: 'userInvitationId',
  companyUserStatus: 'companyUserStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  profileImage: 'profileImage'
};

exports.Prisma.ContactInfoScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  phoneNumber: 'phoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DemographicInfoScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  workHistory: 'workHistory',
  raceEthnicity: 'raceEthnicity',
  veteranStatus: 'veteranStatus',
  gender: 'gender',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EducationScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  companyGlobalId: 'companyGlobalId',
  institutionName: 'institutionName',
  currentlyStudying: 'currentlyStudying',
  educationLevel: 'educationLevel',
  startDate: 'startDate',
  endDate: 'endDate',
  areasOfStudy: 'areasOfStudy',
  majors: 'majors',
  minors: 'minors',
  cumGPA: 'cumGPA',
  cumGPAScale: 'cumGPAScale',
  hideCumGPA: 'hideCumGPA',
  departmentCumGPA: 'departmentCumGPA',
  departmentCumGPAScale: 'departmentCumGPAScale',
  hideDepartmentGPA: 'hideDepartmentGPA',
  additionalInformation: 'additionalInformation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailVerificationScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  emailAddress: 'emailAddress',
  emailVerified: 'emailVerified',
  isPrimary: 'isPrimary',
  isVisibleToEmployers: 'isVisibleToEmployers',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activeStatus: 'activeStatus',
  emailVerificationCode: 'emailVerificationCode'
};

exports.Prisma.CalendarEventScalarFieldEnum = {
  id: 'id',
  calendarId: 'calendarId',
  companyUserId: 'companyUserId',
  nylasCalendarEventId: 'nylasCalendarEventId',
  nylasEventStatus: 'nylasEventStatus',
  title: 'title',
  eventType: 'eventType',
  description: 'description',
  startTime: 'startTime',
  endTime: 'endTime',
  timeZone: 'timeZone',
  location: 'location',
  repeats: 'repeats',
  reminders: 'reminders',
  employers: 'employers',
  conferencing: 'conferencing',
  masterEventId: 'masterEventId',
  regardingCandidates: 'regardingCandidates',
  regardingJobs: 'regardingJobs',
  internalGuests: 'internalGuests',
  candidates: 'candidates',
  isScalisEvent: 'isScalisEvent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  nylasConfigurationId: 'nylasConfigurationId',
  candidateInterviewId: 'candidateInterviewId',
  candidateInterviewLoopId: 'candidateInterviewLoopId',
  isDebriefEvent: 'isDebriefEvent'
};

exports.Prisma.EventAttachmentScalarFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  file: 'file',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EventJobScalarFieldEnum = {
  id: 'id',
  calendarEventId: 'calendarEventId',
  jobId: 'jobId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExperienceScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  companyGlobalId: 'companyGlobalId',
  startDate: 'startDate',
  endDate: 'endDate',
  locationType: 'locationType',
  location: 'location',
  shortFormDesc: 'shortFormDesc',
  longFormDesc: 'longFormDesc',
  searchShortFormDesc: 'searchShortFormDesc',
  searchLongFormDesc: 'searchLongFormDesc',
  industry: 'industry',
  subIndustry: 'subIndustry',
  payType: 'payType',
  jobPay: 'jobPay',
  additionalComp: 'additionalComp',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  managementPosition: 'managementPosition',
  teamSize: 'teamSize',
  workPlaceCandidate: 'workPlaceCandidate',
  isCurrentJob: 'isCurrentJob',
  jobType: 'jobType',
  isCurrentlyWorking: 'isCurrentlyWorking',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HiringTeamMemberScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  companyUserId: 'companyUserId',
  roleId: 'roleId',
  requisitionJobDescriptionId: 'requisitionJobDescriptionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateCollaboratorScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  companyUserId: 'companyUserId',
  candidateProfileId: 'candidateProfileId',
  roleId: 'roleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requisitionJobDescriptionId: 'requisitionJobDescriptionId'
};

exports.Prisma.StageCollaboratorScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  companyUserId: 'companyUserId',
  templateStageId: 'templateStageId',
  roleId: 'roleId',
  requisitionJobDescriptionId: 'requisitionJobDescriptionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobInviteScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  candidateApplicationId: 'candidateApplicationId',
  sentAt: 'sentAt',
  inviteStatus: 'inviteStatus',
  token: 'token',
  dismissed: 'dismissed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobListingScalarFieldEnum = {
  id: 'id',
  publicListingId: 'publicListingId',
  externalListingId: 'externalListingId',
  jobRequisitionId: 'jobRequisitionId',
  listingTitle: 'listingTitle',
  externalTitle: 'externalTitle',
  workplaceType: 'workplaceType',
  publicDescription: 'publicDescription',
  internalMatchingDescription: 'internalMatchingDescription',
  searchPublicDescription: 'searchPublicDescription',
  searchInternalMatchingDescription: 'searchInternalMatchingDescription',
  postedAt: 'postedAt',
  acceptingCandidates: 'acceptingCandidates',
  stage: 'stage',
  displayPayOnListing: 'displayPayOnListing',
  industry: 'industry',
  subIndustry: 'subIndustry',
  companyDefault: 'companyDefault',
  stateAndOrCountry: 'stateAndOrCountry',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  viewCount: 'viewCount',
  defaultConnectedEmailSettingsId: 'defaultConnectedEmailSettingsId'
};

exports.Prisma.JobListingJobPipelineScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  jobPipelineId: 'jobPipelineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobListingScreeningQuestionScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  displaySequenceNumber: 'displaySequenceNumber',
  screeningQuestionId: 'screeningQuestionId',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobOpeningScalarFieldEnum = {
  id: 'id',
  jobRequisitionId: 'jobRequisitionId',
  openingStatus: 'openingStatus',
  extOpeningId: 'extOpeningId',
  companyId: 'companyId',
  targetHireDate: 'targetHireDate',
  openingType: 'openingType',
  filledDate: 'filledDate',
  startDate: 'startDate',
  closedDate: 'closedDate',
  filledByApplication: 'filledByApplication',
  filledByCandidate: 'filledByCandidate',
  closedReason: 'closedReason'
};

exports.Prisma.JobPipelineScalarFieldEnum = {
  id: 'id',
  title: 'title',
  jobRequisitionId: 'jobRequisitionId',
  templatePipelineId: 'templatePipelineId'
};

exports.Prisma.JobSeekerHeaderScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  profileHeadline: 'profileHeadline',
  jobDisplayedId: 'jobDisplayedId',
  educationDisplayedId: 'educationDisplayedId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobSeekerInfoScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  messageUserId: 'messageUserId',
  searchingJobs: 'searchingJobs',
  yearsInWorkforce: 'yearsInWorkforce',
  yearsOfExperience: 'yearsOfExperience',
  jobType: 'jobType',
  currPrefRoles: 'currPrefRoles',
  jobLevel: 'jobLevel',
  teamSize: 'teamSize',
  employStatus: 'employStatus',
  searchStatus: 'searchStatus',
  consideringOffers: 'consideringOffers',
  payType: 'payType',
  desiredPay: 'desiredPay',
  willingToRelocate: 'willingToRelocate',
  locationsWillRelocate: 'locationsWillRelocate',
  tryingToRelocate: 'tryingToRelocate',
  jobTypePref: 'jobTypePref',
  canStartNewJob: 'canStartNewJob',
  nonTraditionalStatus: 'nonTraditionalStatus',
  aboutMe: 'aboutMe',
  hasFinishedOnboarding: 'hasFinishedOnboarding',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobSeekerSkillScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  skillId: 'skillId',
  displayName: 'displayName',
  sequenceNumber: 'sequenceNumber',
  level: 'level',
  yearsOfExp: 'yearsOfExp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobSeekerSkillExperienceScalarFieldEnum = {
  id: 'id',
  jobSeekerSkillId: 'jobSeekerSkillId',
  experienceId: 'experienceId'
};

exports.Prisma.CalendarSettingsScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  availability: 'availability',
  provider: 'provider',
  timeZone: 'timeZone',
  hourDisplay: 'hourDisplay',
  email: 'email',
  nylasGrantId: 'nylasGrantId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConnectedEmailSettingsScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  nylasGrantId: 'nylasGrantId',
  provider: 'provider',
  email: 'email',
  dailyLimit: 'dailyLimit',
  hourlyLimit: 'hourlyLimit',
  minutesBetweenEmails: 'minutesBetweenEmails',
  allowSendOnBehalf: 'allowSendOnBehalf',
  optOutEnabled: 'optOutEnabled',
  emailSignatureEnabled: 'emailSignatureEnabled',
  optOutMessage: 'optOutMessage',
  emailSignature: 'emailSignature',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailConnectionScalarFieldEnum = {
  id: 'id',
  emailRecordId: 'emailRecordId',
  name: 'name',
  emailAddress: 'emailAddress',
  connectedEmailSettingsId: 'connectedEmailSettingsId',
  emailVerificationId: 'emailVerificationId',
  emailAddressConnectionType: 'emailAddressConnectionType',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailRecordScalarFieldEnum = {
  id: 'id',
  emailThreadId: 'emailThreadId',
  externalEmailId: 'externalEmailId',
  externalThreadId: 'externalThreadId',
  subject: 'subject',
  message: 'message',
  provider: 'provider',
  attachments: 'attachments',
  trackOpen: 'trackOpen',
  trackLinks: 'trackLinks',
  trackReply: 'trackReply',
  hasOpened: 'hasOpened',
  hasClicked: 'hasClicked',
  hasReplied: 'hasReplied',
  hasBounced: 'hasBounced',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailThreadScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  externalThreadId: 'externalThreadId',
  companyId: 'companyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConnectedEmailScalarFieldEnum = {
  id: 'id',
  connectedEmailSettingsId: 'connectedEmailSettingsId',
  companyUserId: 'companyUserId',
  candidateApplicationId: 'candidateApplicationId',
  candidateProfileId: 'candidateProfileId',
  emailId: 'emailId',
  threadId: 'threadId',
  from: 'from',
  to: 'to',
  subject: 'subject',
  message: 'message',
  attachments: 'attachments',
  trackOpen: 'trackOpen',
  trackLinks: 'trackLinks',
  trackReply: 'trackReply',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConnectedEmailTrackScalarFieldEnum = {
  id: 'id',
  connectedEmailId: 'connectedEmailId',
  opened: 'opened',
  clicked: 'clicked',
  replied: 'replied',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateIncomingEmailScalarFieldEnum = {
  id: 'id',
  emailId: 'emailId',
  threadId: 'threadId',
  companyId: 'companyId',
  candidateProfileId: 'candidateProfileId',
  from: 'from',
  to: 'to',
  subject: 'subject',
  message: 'message',
  attachments: 'attachments',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CalendarScalarFieldEnum = {
  id: 'id',
  name: 'name',
  nylasCalendarId: 'nylasCalendarId',
  isPrimary: 'isPrimary',
  color: 'color',
  calendarSettingsId: 'calendarSettingsId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ProfileDetailsScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  phoneNumber: 'phoneNumber',
  profileLink: 'profileLink',
  timezone: 'timezone',
  secondaryEmail: 'secondaryEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyProvidedEmailScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RejectCandidateQuestionScalarFieldEnum = {
  id: 'id',
  question: 'question',
  sequence: 'sequence',
  required: 'required',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RejectCandidateQuestionRatingScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  applicationRejectionId: 'applicationRejectionId',
  rejectCandidateQuestionId: 'rejectCandidateQuestionId',
  score: 'score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RequisitionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyDepartmentId: 'companyDepartmentId',
  companyOfficeId: 'companyOfficeId',
  approvalWorkflowJSON: 'approvalWorkflowJSON',
  approvalStatus: 'approvalStatus',
  extRequisitionId: 'extRequisitionId',
  jobType: 'jobType',
  jobLevel: 'jobLevel',
  benefits: 'benefits',
  payType: 'payType',
  minPay: 'minPay',
  maxPay: 'maxPay',
  additionalComp: 'additionalComp',
  teamSize: 'teamSize',
  jobName: 'jobName',
  yearsOfExperiencePref: 'yearsOfExperiencePref',
  locationDistancePref: 'locationDistancePref',
  nonTraditionalPref: 'nonTraditionalPref',
  diverseHirePref: 'diverseHirePref',
  veteranPref: 'veteranPref',
  collegeGradPref: 'collegeGradPref',
  educationLevelPref: 'educationLevelPref',
  travelType: 'travelType',
  companyUserId: 'companyUserId',
  jobStatus: 'jobStatus',
  primaryContact: 'primaryContact',
  isIncomplete: 'isIncomplete',
  openedAt: 'openedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted'
};

exports.Prisma.RequisitionExtIdScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  extId: 'extId'
};

exports.Prisma.RequisitionJobDescriptionScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RequisitionSkillScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  skillId: 'skillId',
  sequenceNumber: 'sequenceNumber',
  level: 'level',
  yearsOfExp: 'yearsOfExp',
  displayName: 'displayName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.RolePermissionsScalarFieldEnum = {
  roleId: 'roleId',
  permissionId: 'permissionId'
};

exports.Prisma.ScalisUserScalarFieldEnum = {
  id: 'id',
  identityProviderId: 'identityProviderId',
  identityProviderUsername: 'identityProviderUsername',
  firstName: 'firstName',
  lastName: 'lastName',
  passwordResetCode: 'passwordResetCode',
  passwordResetCodeExpiry: 'passwordResetCodeExpiry',
  profileImage: 'profileImage',
  currentStage: 'currentStage',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activeStatus: 'activeStatus',
  stripeCustomerId: 'stripeCustomerId'
};

exports.Prisma.SchedulerLinkInviteScalarFieldEnum = {
  id: 'id',
  applicationId: 'applicationId',
  stageId: 'stageId',
  companyUserId: 'companyUserId',
  calendarId: 'calendarId',
  nylasConfigurationId: 'nylasConfigurationId',
  durationMinutes: 'durationMinutes',
  message: 'message',
  candidateData: 'candidateData',
  interviewData: 'interviewData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SchedulerLinkSettingsScalarFieldEnum = {
  id: 'id',
  minimumHour: 'minimumHour',
  rollingDays: 'rollingDays',
  maxInterviewsPerDay: 'maxInterviewsPerDay',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScorecardTemplateScalarFieldEnum = {
  id: 'id',
  scorecardName: 'scorecardName',
  scorecardDescription: 'scorecardDescription',
  department: 'department',
  companyId: 'companyId',
  companyTemplate: 'companyTemplate',
  archived: 'archived',
  visible: 'visible',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  timestampAt: 'timestampAt',
  isDeleted: 'isDeleted',
  replacedByVersionId: 'replacedByVersionId'
};

exports.Prisma.ScorecardTemplateQuestionScalarFieldEnum = {
  id: 'id',
  scorecardTemplateSectionId: 'scorecardTemplateSectionId',
  questionType: 'questionType',
  skillDisplayName: 'skillDisplayName',
  skillId: 'skillId',
  questionText: 'questionText',
  questionDescription: 'questionDescription',
  answerOptions: 'answerOptions',
  preferredAnswer: 'preferredAnswer',
  scoreAnswer: 'scoreAnswer',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScorecardTemplateSectionScalarFieldEnum = {
  id: 'id',
  scorecardTemplateId: 'scorecardTemplateId',
  sectionType: 'sectionType',
  sectionName: 'sectionName',
  rankOrder: 'rankOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScreeningQuestionScalarFieldEnum = {
  id: 'id',
  questionTitle: 'questionTitle',
  questionDesc: 'questionDesc',
  questionType: 'questionType',
  minVal: 'minVal',
  maxVal: 'maxVal',
  valStatus: 'valStatus',
  ansOptions: 'ansOptions',
  isRejectionQuestion: 'isRejectionQuestion',
  rejectMessage: 'rejectMessage',
  templateMessageId: 'templateMessageId',
  preferredAnswer: 'preferredAnswer',
  preferredAnswerType: 'preferredAnswerType',
  multipleSelectPreferredAnswers: 'multipleSelectPreferredAnswers',
  selectionDisplay: 'selectionDisplay',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  customCandidateApplicationFieldId: 'customCandidateApplicationFieldId',
  isTemplateQuestion: 'isTemplateQuestion',
  isGlobalQuestion: 'isGlobalQuestion',
  isActiveGlobally: 'isActiveGlobally',
  globalQuestionOrder: 'globalQuestionOrder',
  isEdited: 'isEdited',
  isReplacedBy: 'isReplacedBy',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScreeningQuestionAnswerScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  listingScreeningQuestionId: 'listingScreeningQuestionId',
  answerStatus: 'answerStatus',
  answer: 'answer',
  multipleSelectAnswers: 'multipleSelectAnswers',
  uploadedDocumentCandidateApplicationId: 'uploadedDocumentCandidateApplicationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApplicationFormScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  companyDepartmentId: 'companyDepartmentId',
  companyOfficeId: 'companyOfficeId',
  name: 'name',
  isArchived: 'isArchived',
  isEdited: 'isEdited',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApplicationFormScreeningQuestionScalarFieldEnum = {
  id: 'id',
  screeningQuestionId: 'screeningQuestionId',
  applicationFormId: 'applicationFormId',
  rankOrder: 'rankOrder',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SkillScalarFieldEnum = {
  id: 'id',
  name: 'name',
  skillType: 'skillType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StageSettingsScalarFieldEnum = {
  id: 'id',
  jobPipelineId: 'jobPipelineId',
  templateStageId: 'templateStageId',
  scorecardTemplateId: 'scorecardTemplateId',
  interviewLength: 'interviewLength',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterviewTeamScalarFieldEnum = {
  id: 'id',
  stageSettingsId: 'stageSettingsId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateJobDescriptionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  name: 'name',
  description: 'description',
  companyDepartmentId: 'companyDepartmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateMessageScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  title: 'title',
  message: 'message',
  messageType: 'messageType',
  messageOwner: 'messageOwner',
  emailSubject: 'emailSubject',
  senderAddressId: 'senderAddressId',
  ccEmails: 'ccEmails',
  bccEmails: 'bccEmails',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateMilestoneScalarFieldEnum = {
  id: 'id',
  templatePipelineId: 'templatePipelineId',
  name: 'name',
  rankOrder: 'rankOrder',
  archived: 'archived',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplatePipelineScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  name: 'name',
  companyDepartmentId: 'companyDepartmentId',
  pipelinedUsed: 'pipelinedUsed',
  archived: 'archived',
  ghostPipeline: 'ghostPipeline',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TemplateStageScalarFieldEnum = {
  id: 'id',
  templatePipelineId: 'templatePipelineId',
  visibility: 'visibility',
  name: 'name',
  templateMilestoneId: 'templateMilestoneId',
  rankOrder: 'rankOrder',
  archived: 'archived',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateMergeScalarFieldEnum = {
  id: 'id',
  scrapedCandidateId: 'scrapedCandidateId',
  mergedCandidateId: 'mergedCandidateId',
  mergedAt: 'mergedAt'
};

exports.Prisma.EnrichedLocationScalarFieldEnum = {
  id: 'id',
  location: 'location',
  recommended: 'recommended',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  uploadedCandidateId: 'uploadedCandidateId'
};

exports.Prisma.EnrichedPhoneNumberScalarFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  phoneNumberType: 'phoneNumberType',
  recommended: 'recommended',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  uploadedCandidateId: 'uploadedCandidateId'
};

exports.Prisma.EnrichedEmailScalarFieldEnum = {
  id: 'id',
  emailAddress: 'emailAddress',
  enrichedEmailType: 'enrichedEmailType',
  recommended: 'recommended',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  uploadedCandidateId: 'uploadedCandidateId'
};

exports.Prisma.UploadedCandidateScalarFieldEnum = {
  id: 'id',
  emailAddress: 'emailAddress',
  firstName: 'firstName',
  lastName: 'lastName',
  linkedinProfile: 'linkedinProfile',
  profileUrl: 'profileUrl',
  profileImage: 'profileImage',
  uploadedCandidateType: 'uploadedCandidateType',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateAchievementScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  issueYear: 'issueYear',
  description: 'description',
  searchDescription: 'searchDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateCertificateOrLicenseScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  issueYear: 'issueYear',
  description: 'description',
  searchDescription: 'searchDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateEducationScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  companyGlobalId: 'companyGlobalId',
  institutionName: 'institutionName',
  currentlyStudying: 'currentlyStudying',
  educationLevel: 'educationLevel',
  startDate: 'startDate',
  endDate: 'endDate',
  areasOfStudy: 'areasOfStudy',
  majors: 'majors',
  minors: 'minors',
  cumGPA: 'cumGPA',
  cumGPAScale: 'cumGPAScale',
  hideCumGPA: 'hideCumGPA',
  departmentCumGPA: 'departmentCumGPA',
  departmentCumGPAScale: 'departmentCumGPAScale',
  hideDepartmentGPA: 'hideDepartmentGPA',
  additionalInformation: 'additionalInformation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateExperienceScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  companyGlobalId: 'companyGlobalId',
  companyLogo: 'companyLogo',
  startDate: 'startDate',
  endDate: 'endDate',
  locationType: 'locationType',
  location: 'location',
  shortFormDesc: 'shortFormDesc',
  longFormDesc: 'longFormDesc',
  searchShortFormDesc: 'searchShortFormDesc',
  searchLongFormDesc: 'searchLongFormDesc',
  industry: 'industry',
  subIndustry: 'subIndustry',
  payType: 'payType',
  jobPay: 'jobPay',
  additionalComp: 'additionalComp',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  managementPosition: 'managementPosition',
  teamSize: 'teamSize',
  workPlaceCandidate: 'workPlaceCandidate',
  isCurrentJob: 'isCurrentJob',
  jobType: 'jobType',
  isCurrentlyWorking: 'isCurrentlyWorking',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateJobSeekerSkillScalarFieldEnum = {
  id: 'id',
  skillId: 'skillId',
  sequenceNumber: 'sequenceNumber',
  uploadedCandidateId: 'uploadedCandidateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateSkillScalarFieldEnum = {
  id: 'id',
  experienceId: 'experienceId',
  name: 'name',
  level: 'level',
  yearsOfExp: 'yearsOfExp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateVolunteerWorkScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  volunteerJobTitle: 'volunteerJobTitle',
  organizationName: 'organizationName',
  isCurrentlyWorking: 'isCurrentlyWorking',
  roleType: 'roleType',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  searchDescription: 'searchDescription',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedCandidateWebsiteOrSocialMediaScalarFieldEnum = {
  id: 'id',
  uploadedCandidateId: 'uploadedCandidateId',
  websiteURL: 'websiteURL',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedDocumentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  documentPath: 'documentPath',
  documentName: 'documentName'
};

exports.Prisma.UploadedDocumentCandidateApplicationScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  uploadedDocumentId: 'uploadedDocumentId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedDocumentCandidateProfileScalarFieldEnum = {
  id: 'id',
  candidateProfileId: 'candidateProfileId',
  uploadedDocumentId: 'uploadedDocumentId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScalisUserUploadedDocumentScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  documentPath: 'documentPath',
  documentName: 'documentName',
  documentType: 'documentType',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt'
};

exports.Prisma.UserInvitationScalarFieldEnum = {
  id: 'id',
  verificationCode: 'verificationCode',
  email: 'email',
  companyId: 'companyId',
  invitedAs: 'invitedAs',
  invitationStatus: 'invitationStatus',
  scalisUserId: 'scalisUserId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserNoteScalarFieldEnum = {
  id: 'id',
  noteText: 'noteText',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserRolesScalarFieldEnum = {
  userId: 'userId',
  roleId: 'roleId'
};

exports.Prisma.VolunteerWorkScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  companyGlobalId: 'companyGlobalId',
  volunteerJobTitle: 'volunteerJobTitle',
  organizationName: 'organizationName',
  isCurrentlyWorking: 'isCurrentlyWorking',
  roleType: 'roleType',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  searchDescription: 'searchDescription',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebsiteOrSocialMediaScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  websiteURL: 'websiteURL',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalJobApplicationScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  userId: 'userId',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  jobUrl: 'jobUrl',
  location: 'location',
  status: 'status',
  appliedAt: 'appliedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobAdCampaignScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  orderId: 'orderId',
  vonqCampaignId: 'vonqCampaignId',
  vonqVacancy: 'vonqVacancy',
  requisitionId: 'requisitionId',
  jobListingId: 'jobListingId',
  campaignName: 'campaignName',
  viewCount: 'viewCount',
  targetGroup: 'targetGroup',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  requisitionId: 'requisitionId',
  orderReference: 'orderReference',
  subTotal: 'subTotal',
  vat: 'vat',
  total: 'total',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AiFeatureUsageScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  featureName: 'featureName',
  createdAt: 'createdAt'
};

exports.Prisma.UserSubscriptionScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  stripeCustomerId: 'stripeCustomerId',
  subscriptionId: 'subscriptionId',
  status: 'status',
  productId: 'productId',
  currentPeriodStart: 'currentPeriodStart',
  currentPeriodEnd: 'currentPeriodEnd',
  canceledAt: 'canceledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateOfferScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateOfferVersionScalarFieldEnum = {
  id: 'id',
  candidateOfferId: 'candidateOfferId',
  version: 'version',
  candidateName: 'candidateName',
  jobTitle: 'jobTitle',
  manager: 'manager',
  startDate: 'startDate',
  jobType: 'jobType',
  payType: 'payType',
  benefits: 'benefits',
  expirationDate: 'expirationDate',
  companyOfficeId: 'companyOfficeId',
  compensation: 'compensation',
  additionalCompensation: 'additionalCompensation',
  offerStatus: 'offerStatus',
  offerDocumentTemplateId: 'offerDocumentTemplateId',
  signatureRequestId: 'signatureRequestId',
  lastUpdatedStatusAt: 'lastUpdatedStatusAt',
  createdAt: 'createdAt'
};

exports.Prisma.CandidateOfferVersionSignatureScalarFieldEnum = {
  id: 'id',
  candidateOfferVersionId: 'candidateOfferVersionId',
  emailAddress: 'emailAddress',
  name: 'name',
  order: 'order',
  externalId: 'externalId',
  externalStatus: 'externalStatus',
  status: 'status',
  signedAt: 'signedAt',
  viewedAt: 'viewedAt',
  remindedAt: 'remindedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateOfferCustomFieldScalarFieldEnum = {
  id: 'id',
  candidateOfferVersionId: 'candidateOfferVersionId',
  fieldValue: 'fieldValue',
  offerCustomFieldId: 'offerCustomFieldId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateOfferFileScalarFieldEnum = {
  id: 'id',
  filePath: 'filePath',
  fileName: 'fileName',
  fileType: 'fileType',
  createdAt: 'createdAt',
  candidateOfferVersionId: 'candidateOfferVersionId'
};

exports.Prisma.DefaultTokenScalarFieldEnum = {
  id: 'id',
  tokenType: 'tokenType',
  tokenName: 'tokenName',
  categoryName: 'categoryName',
  tableName: 'tableName',
  columnName: 'columnName',
  isAggregatedToken: 'isAggregatedToken',
  createdAt: 'createdAt'
};

exports.Prisma.OfferDocumentTemplateScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  documentTemplateText: 'documentTemplateText',
  documentTemplateName: 'documentTemplateName',
  documentType: 'documentType',
  documentTemplateStatus: 'documentTemplateStatus',
  documentFilePath: 'documentFilePath',
  documentFileName: 'documentFileName',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OfferTemplateConditionScalarFieldEnum = {
  id: 'id',
  conditionType: 'conditionType',
  officeId: 'officeId',
  departmentId: 'departmentId',
  payType: 'payType',
  employmentType: 'employmentType',
  sectionTemplateId: 'sectionTemplateId',
  offerDocumentTemplateId: 'offerDocumentTemplateId',
  customFieldId: 'customFieldId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OfferSectionTemplateScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  templateConditionId: 'templateConditionId',
  sectionTemplateName: 'sectionTemplateName',
  tokenDescription: 'tokenDescription',
  sectionToken: 'sectionToken',
  sectionTemplateText: 'sectionTemplateText',
  sectionTemplateStatus: 'sectionTemplateStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OfferDocumentTemplateSectionScalarFieldEnum = {
  offerDocumentTemplateId: 'offerDocumentTemplateId',
  offerSectionTemplateId: 'offerSectionTemplateId'
};

exports.Prisma.OfferCustomFieldScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  templateConditionId: 'templateConditionId',
  fieldConfigurationType: 'fieldConfigurationType',
  fieldName: 'fieldName',
  fieldDescription: 'fieldDescription',
  generateSystemToken: 'generateSystemToken',
  systemTokenName: 'systemTokenName',
  multipleChoiceOptions: 'multipleChoiceOptions',
  fieldRequired: 'fieldRequired',
  triggerNewOfferVersion: 'triggerNewOfferVersion',
  createdAt: 'createdAt',
  deleted: 'deleted',
  isArchived: 'isArchived',
  updatedAt: 'updatedAt'
};

exports.Prisma.TokenTestResultScalarFieldEnum = {
  id: 'id',
  offerDocumentTemplateId: 'offerDocumentTemplateId',
  offerSectionTemplateId: 'offerSectionTemplateId',
  result: 'result',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateOfferRejectionScalarFieldEnum = {
  id: 'id',
  candidateOfferId: 'candidateOfferId',
  reason: 'reason',
  wantsToProvideReason: 'wantsToProvideReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateApplicationStatusScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  jobListingId: 'jobListingId',
  candidateApplicationId: 'candidateApplicationId',
  campaignId: 'campaignId',
  source: 'source',
  startedAt: 'startedAt',
  completedAt: 'completedAt'
};

exports.Prisma.CoreReportScalarFieldEnum = {
  id: 'id',
  reportName: 'reportName',
  companyId: 'companyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScheduledReportScalarFieldEnum = {
  id: 'id',
  coreReportId: 'coreReportId',
  reportSchedulerType: 'reportSchedulerType',
  taskId: 'taskId',
  taskObject: 'taskObject',
  recipients: 'recipients',
  cronExpression: 'cronExpression',
  startDate: 'startDate',
  endDate: 'endDate',
  companyUserId: 'companyUserId',
  repeat: 'repeat',
  customDaysOfWeek: 'customDaysOfWeek',
  customTime: 'customTime',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FavoriteCoreReportScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  coreReportId: 'coreReportId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SharedCoreReportScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  coreReportId: 'coreReportId',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CoreReportFilterScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyUserId: 'companyUserId',
  coreReportId: 'coreReportId',
  filters: 'filters',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobListingVectorsScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobListingScoresScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  scalisUserId: 'scalisUserId',
  score: 'score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ScalisApplicationParameterScalarFieldEnum = {
  id: 'id',
  emailProvider: 'emailProvider',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GlobalListingSetupScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  aboutCompanyStatement: 'aboutCompanyStatement',
  footerStatement: 'footerStatement',
  isAboutCompanyActive: 'isAboutCompanyActive',
  isFooterStatementActive: 'isFooterStatementActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyUserGroupScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  name: 'name',
  externalId: 'externalId',
  companyUserId: 'companyUserId',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyUserGroupCompanyUserScalarFieldEnum = {
  id: 'id',
  companyUserGroupId: 'companyUserGroupId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt'
};

exports.Prisma.CompanyUserGroupCompanyOfficeScalarFieldEnum = {
  id: 'id',
  companyUserGroupId: 'companyUserGroupId',
  officeId: 'officeId',
  createdAt: 'createdAt'
};

exports.Prisma.CompanyUserGroupCompanyDepartmentScalarFieldEnum = {
  id: 'id',
  companyUserGroupId: 'companyUserGroupId',
  departmentId: 'departmentId',
  createdAt: 'createdAt'
};

exports.Prisma.CompanySavedViewScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  companyId: 'companyId',
  candidateFilterId: 'candidateFilterId',
  name: 'name',
  viewType: 'viewType',
  viewLayout: 'viewLayout',
  viewLocation: 'viewLocation',
  isVisibleTo: 'isVisibleTo',
  sorting: 'sorting',
  columnVisibility: 'columnVisibility',
  columnOrder: 'columnOrder',
  columnSizing: 'columnSizing',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RequisitionTalentPoolCompanySavedViewScalarFieldEnum = {
  id: 'id',
  companySavedViewId: 'companySavedViewId',
  requisitionId: 'requisitionId',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  talentPoolId: 'talentPoolId',
  isPinned: 'isPinned',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentPoolScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  ownerCompanyUserId: 'ownerCompanyUserId',
  name: 'name',
  description: 'description',
  isVisibleTo: 'isVisibleTo',
  talentPoolType: 'talentPoolType',
  isArchived: 'isArchived',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyUserViewScalarFieldEnum = {
  id: 'id',
  requisitionTalentPoolCompanySavedViewId: 'requisitionTalentPoolCompanySavedViewId',
  companyUserId: 'companyUserId',
  rankOrder: 'rankOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  wasRemovedFromUserView: 'wasRemovedFromUserView'
};

exports.Prisma.TalentPoolCandidateProfileScalarFieldEnum = {
  id: 'id',
  talentPoolId: 'talentPoolId',
  candidateProfileId: 'candidateProfileId',
  talentPoolProspectStatusId: 'talentPoolProspectStatusId',
  prospectOwnerId: 'prospectOwnerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateFilterScalarFieldEnum = {
  id: 'id',
  name: 'name',
  filters: 'filters',
  companyUserId: 'companyUserId',
  companyId: 'companyId',
  isDefaultFilter: 'isDefaultFilter',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobSearchPreferenceScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  includeJobTitles: 'includeJobTitles',
  excludeJobTitles: 'excludeJobTitles',
  jobType: 'jobType',
  datePosted: 'datePosted',
  workplaceTypePreference: 'workplaceTypePreference',
  workplaceLocationPreference: 'workplaceLocationPreference',
  relocationTypePreference: 'relocationTypePreference',
  relocationLocationPreference: 'relocationLocationPreference',
  minimumPayPreference: 'minimumPayPreference',
  visaSponsorship: 'visaSponsorship',
  benefits: 'benefits',
  industryPreference: 'industryPreference',
  desiredCompanySize: 'desiredCompanySize',
  companyStage: 'companyStage',
  minimumRequiredExperience: 'minimumRequiredExperience',
  maxRequiredExperience: 'maxRequiredExperience',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobListingRecommendationScalarFieldEnum = {
  id: 'id',
  jobListingId: 'jobListingId',
  companyId: 'companyId',
  scalisUsers: 'scalisUsers',
  createdAt: 'createdAt'
};

exports.Prisma.ScalisUserRecommendationScalarFieldEnum = {
  id: 'id',
  scalisUserId: 'scalisUserId',
  jobListings: 'jobListings',
  createdAt: 'createdAt'
};

exports.Prisma.ApprovalWorkflowScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  scope: 'scope',
  uniqueId: 'uniqueId',
  isDefault: 'isDefault',
  workflowJSON: 'workflowJSON',
  isActive: 'isActive',
  createdByUserId: 'createdByUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateLabelScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  labelName: 'labelName',
  colorNumber: 'colorNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateLabelCandidateProfileScalarFieldEnum = {
  id: 'id',
  candidateLabelId: 'candidateLabelId',
  candidateProfileId: 'candidateProfileId',
  createdAt: 'createdAt'
};

exports.Prisma.TalentPoolTagScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  tagName: 'tagName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentPoolTagTalentPoolScalarFieldEnum = {
  id: 'id',
  talentPoolTagId: 'talentPoolTagId',
  talentPoolId: 'talentPoolId',
  createdAt: 'createdAt'
};

exports.Prisma.TalentPoolAssociatedRequisitionScalarFieldEnum = {
  id: 'id',
  talentPoolId: 'talentPoolId',
  requisitionId: 'requisitionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentPoolContributorScalarFieldEnum = {
  id: 'id',
  talentPoolId: 'talentPoolId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FavoriteTalentPoolScalarFieldEnum = {
  id: 'id',
  talentPoolId: 'talentPoolId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TalentPoolProspectStatusScalarFieldEnum = {
  id: 'id',
  status: 'status',
  colorNumber: 'colorNumber',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomApplicationStatusScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  applicationStatusName: 'applicationStatusName',
  colorHexCode: 'colorHexCode',
  iconUnicode: 'iconUnicode',
  iconType: 'iconType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomCandidateProfileFieldScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyId: 'companyId',
  schema: 'schema',
  type: 'type',
  requisitionId: 'requisitionId',
  isArchived: 'isArchived',
  visibility: 'visibility',
  provider: 'provider',
  tooltip: 'tooltip',
  tooltipText: 'tooltipText',
  showWhenUploadingCandidate: 'showWhenUploadingCandidate',
  requireWhenUploadingCandidate: 'requireWhenUploadingCandidate',
  systemTokenName: 'systemTokenName',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomCandidateProfileFieldValueScalarFieldEnum = {
  id: 'id',
  customCandidateProfileFieldId: 'customCandidateProfileFieldId',
  candidateProfileId: 'candidateProfileId',
  value: 'value',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomCandidateApplicationFieldScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyId: 'companyId',
  schema: 'schema',
  type: 'type',
  isArchived: 'isArchived',
  visibility: 'visibility',
  provider: 'provider',
  tooltip: 'tooltip',
  tooltipText: 'tooltipText',
  showWhenUploadingCandidate: 'showWhenUploadingCandidate',
  requireWhenUploadingCandidate: 'requireWhenUploadingCandidate',
  systemTokenName: 'systemTokenName',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomCandidateApplicationFieldRequisitionScalarFieldEnum = {
  id: 'id',
  customCandidateApplicationFieldId: 'customCandidateApplicationFieldId',
  requisitionId: 'requisitionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomCandidateApplicationFieldValueScalarFieldEnum = {
  id: 'id',
  customCandidateApplicationFieldId: 'customCandidateApplicationFieldId',
  candidateApplicationId: 'candidateApplicationId',
  value: 'value',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SequenceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  ownerCompanyUserId: 'ownerCompanyUserId',
  sequenceStatus: 'sequenceStatus',
  visibility: 'visibility',
  sequenceSettingId: 'sequenceSettingId',
  archivedReason: 'archivedReason',
  isDeleted: 'isDeleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FavoriteSequenceScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SequenceSettingScalarFieldEnum = {
  id: 'id',
  connectedEmailSettingsId: 'connectedEmailSettingsId',
  cc: 'cc',
  bcc: 'bcc',
  companyId: 'companyId',
  pauseOnReply: 'pauseOnReply',
  unenrollOnConversion: 'unenrollOnConversion',
  includeUnsubscribeLink: 'includeUnsubscribeLink',
  unsubscribeLinkText: 'unsubscribeLinkText',
  dailySendLimit: 'dailySendLimit',
  sequenceScheduleSettingId: 'sequenceScheduleSettingId'
};

exports.Prisma.SequenceScheduleSettingScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyId: 'companyId',
  daysOfWeek: 'daysOfWeek',
  isDefault: 'isDefault',
  useContactLocalTime: 'useContactLocalTime',
  timeZone: 'timeZone',
  startTime: 'startTime',
  endTime: 'endTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SequenceStepScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  stepNumber: 'stepNumber',
  schedulerType: 'schedulerType',
  sendTimeType: 'sendTimeType',
  customSendTime: 'customSendTime',
  afterPreviousStep: 'afterPreviousStep',
  spreadStrategy: 'spreadStrategy',
  replyPreviousThread: 'replyPreviousThread',
  emailLimitPerDay: 'emailLimitPerDay',
  templateMessageId: 'templateMessageId',
  subject: 'subject',
  body: 'body',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted'
};

exports.Prisma.SequenceAssociatedRequisitionScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  requisitionId: 'requisitionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SequenceAssociatedTalentPoolScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  talentPoolId: 'talentPoolId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SequenceCandidateScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  candidateProfileId: 'candidateProfileId',
  sequenceCandidateStatus: 'sequenceCandidateStatus',
  currentStepId: 'currentStepId',
  optOutToken: 'optOutToken',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted'
};

exports.Prisma.SequenceActivityLogScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  sequenceCandidateId: 'sequenceCandidateId',
  connectedEmailId: 'connectedEmailId',
  sequenceStepId: 'sequenceStepId',
  candidateIncomingEmailId: 'candidateIncomingEmailId',
  emailRecordId: 'emailRecordId',
  eventObject: 'eventObject',
  eventType: 'eventType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApprovalWorkflowVersionScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  version: 'version',
  previousWorkflowVersion: 'previousWorkflowVersion',
  approvalWorkflowStatus: 'approvalWorkflowStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApprovalWorkflowVersionStepScalarFieldEnum = {
  id: 'id',
  approvalWorkflowVersionId: 'approvalWorkflowVersionId',
  rankOrder: 'rankOrder',
  approvalStepStatus: 'approvalStepStatus',
  approvalStrictnessLevel: 'approvalStrictnessLevel',
  finalStep: 'finalStep',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApprovalWorkflowVersionTemplateMappingScalarFieldEnum = {
  id: 'id',
  templateApprovalWorkflowId: 'templateApprovalWorkflowId',
  approvalWorkflowVersionId: 'approvalWorkflowVersionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApprovalReviewerStatusScalarFieldEnum = {
  id: 'id',
  approvalWorkflowVersionStepId: 'approvalWorkflowVersionStepId',
  approvalReviewStatus: 'approvalReviewStatus',
  companyUserId: 'companyUserId',
  companyUserGroupId: 'companyUserGroupId',
  hiringTeamRole: 'hiringTeamRole',
  respondedToBy: 'respondedToBy',
  comments: 'comments',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateApprovalWorkflowStepScalarFieldEnum = {
  id: 'id',
  templateApprovalWorkflowId: 'templateApprovalWorkflowId',
  rankOrder: 'rankOrder',
  approvalStrictnessLevel: 'approvalStrictnessLevel',
  finalStep: 'finalStep',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateApprovalReviewerScalarFieldEnum = {
  id: 'id',
  templateApprovalWorkflowStepId: 'templateApprovalWorkflowStepId',
  companyUserId: 'companyUserId',
  hiringTeamRole: 'hiringTeamRole',
  companyUserGroupId: 'companyUserGroupId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TemplateApprovalWorkflowScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  companyUserId: 'companyUserId',
  name: 'name',
  description: 'description',
  approvalWorkflowType: 'approvalWorkflowType',
  approvalConditions: 'approvalConditions',
  isEdited: 'isEdited',
  replacedBy: 'replacedBy',
  isDeleted: 'isDeleted',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyApprovalSettingScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  requireJobApproval: 'requireJobApproval',
  requireOpeningApproval: 'requireOpeningApproval',
  requireOfferApproval: 'requireOfferApproval',
  defaultJobApprovalWorkflowId: 'defaultJobApprovalWorkflowId',
  defaultOpeningApprovalWorkflowId: 'defaultOpeningApprovalWorkflowId',
  defaultOfferApprovalWorkflowId: 'defaultOfferApprovalWorkflowId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ApprovalWorkflowEntityMappingScalarFieldEnum = {
  id: 'id',
  requisitionId: 'requisitionId',
  jobOpeningId: 'jobOpeningId',
  candidateOfferVersionId: 'candidateOfferVersionId',
  approvalWorkflowVersionId: 'approvalWorkflowVersionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomJobRequisitionFieldScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyId: 'companyId',
  schema: 'schema',
  type: 'type',
  isArchived: 'isArchived',
  isRequired: 'isRequired',
  visibility: 'visibility',
  provider: 'provider',
  tooltip: 'tooltip',
  tooltipText: 'tooltipText',
  systemTokenName: 'systemTokenName',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomJobRequisitionFieldValueScalarFieldEnum = {
  id: 'id',
  customJobRequisitionFieldId: 'customJobRequisitionFieldId',
  requisitionId: 'requisitionId',
  value: 'value',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyCustomFieldTokenScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  customCandidateApplicationFieldId: 'customCandidateApplicationFieldId',
  customCandidateProfileFieldId: 'customCandidateProfileFieldId',
  offerCustomFieldId: 'offerCustomFieldId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationSettingScalarFieldEnum = {
  id: 'id',
  companyUserId: 'companyUserId',
  eventType: 'eventType',
  inApp: 'inApp',
  email: 'email',
  slack: 'slack',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyGlobalScalarFieldEnum = {
  id: 'id',
  name: 'name',
  headquarters: 'headquarters',
  headcount: 'headcount',
  website: 'website',
  lastFundingRound: 'lastFundingRound',
  logo: 'logo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalId: 'externalId'
};

exports.Prisma.CompanyTagsScalarFieldEnum = {
  id: 'id',
  companyGlobalId: 'companyGlobalId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.IntegrationsNylasNotetakerScalarFieldEnum = {
  id: 'id',
  nylasNotetakerId: 'nylasNotetakerId',
  summary: 'summary',
  transcriptPath: 'transcriptPath',
  recordingPath: 'recordingPath',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterviewerPoolScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  name: 'name',
  description: 'description',
  enableLoadBalancing: 'enableLoadBalancing',
  minWeeklyInterviews: 'minWeeklyInterviews',
  maxWeeklyInterviews: 'maxWeeklyInterviews',
  minDailyInterviews: 'minDailyInterviews',
  maxDailyInterviews: 'maxDailyInterviews',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterviewerPoolMemberScalarFieldEnum = {
  id: 'id',
  interviewerPoolId: 'interviewerPoolId',
  companyUserId: 'companyUserId',
  createdAt: 'createdAt'
};

exports.Prisma.InterviewerPoolDepartmentScalarFieldEnum = {
  id: 'id',
  interviewerPoolId: 'interviewerPoolId',
  companyDepartmentId: 'companyDepartmentId'
};

exports.Prisma.InterviewerPoolOfficeScalarFieldEnum = {
  id: 'id',
  interviewerPoolId: 'interviewerPoolId',
  companyOfficeId: 'companyOfficeId'
};

exports.Prisma.InterviewerPoolJobScalarFieldEnum = {
  id: 'id',
  interviewerPoolId: 'interviewerPoolId',
  requisitionId: 'requisitionId'
};

exports.Prisma.InterviewerPoolSkillScalarFieldEnum = {
  id: 'id',
  interviewerPoolId: 'interviewerPoolId',
  skillId: 'skillId'
};

exports.Prisma.InterviewPoolMemberSkillScalarFieldEnum = {
  id: 'id',
  interviewerPoolMemberId: 'interviewerPoolMemberId',
  interviewerPoolSkillId: 'interviewerPoolSkillId',
  createdAt: 'createdAt'
};

exports.Prisma.InterviewTemplateScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  name: 'name',
  stageType: 'stageType',
  interviewType: 'interviewType',
  schedulingLogic: 'schedulingLogic',
  debriefInterview: 'debriefInterview',
  duration: 'duration',
  interviewerPoolId: 'interviewerPoolId',
  scorecardTemplateId: 'scorecardTemplateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InterviewTemplateLoopScalarFieldEnum = {
  id: 'id',
  interviewTemplateId: 'interviewTemplateId',
  name: 'name',
  duration: 'duration',
  rankOrder: 'rankOrder',
  scorecardTemplateId: 'scorecardTemplateId'
};

exports.Prisma.CandidateInterviewLoopScalarFieldEnum = {
  id: 'id',
  candidateInterviewId: 'candidateInterviewId',
  interviewTemplateLoopId: 'interviewTemplateLoopId',
  name: 'name',
  duration: 'duration',
  rankOrder: 'rankOrder',
  scorecardTemplateId: 'scorecardTemplateId',
  assignedUserId: 'assignedUserId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateAvailabilityRequestScalarFieldEnum = {
  id: 'id',
  candidateApplicationId: 'candidateApplicationId',
  candidateName: 'candidateName',
  interviewTitle: 'interviewTitle',
  duration: 'duration',
  timeZone: 'timeZone',
  notes: 'notes',
  status: 'status',
  templateStageId: 'templateStageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CandidateAvailabilitySlotScalarFieldEnum = {
  id: 'id',
  candidateAvailabilityRequestId: 'candidateAvailabilityRequestId',
  startTime: 'startTime',
  endTime: 'endTime',
  rankOrder: 'rankOrder',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.AchievementOrderByRelevanceFieldEnum = {
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  searchDescription: 'searchDescription'
};

exports.Prisma.ActivityLogOrderByRelevanceFieldEnum = {
  userIp: 'userIp'
};

exports.Prisma.AddressOrderByRelevanceFieldEnum = {
  contactName: 'contactName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  timeZone: 'timeZone',
  longitude: 'longitude',
  latitude: 'latitude'
};

exports.Prisma.ApplicationRejectionOrderByRelevanceFieldEnum = {
  details: 'details'
};

exports.Prisma.BookmarkedJobOrderByRelevanceFieldEnum = {
  publicListingId: 'publicListingId'
};

exports.Prisma.CandidateMedalistDesignationOrderByRelevanceFieldEnum = {
  medalistDesignation: 'medalistDesignation'
};

exports.Prisma.CandidateMessageOrderByRelevanceFieldEnum = {
  customMessage: 'customMessage'
};

exports.Prisma.CandidateProfileOrderByRelevanceFieldEnum = {
  primaryEmail: 'primaryEmail'
};

exports.Prisma.CandidateProfileLocationOrderByRelevanceFieldEnum = {
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country'
};

exports.Prisma.CandidateScorecardOrderByRelevanceFieldEnum = {
  additionalInformation: 'additionalInformation'
};

exports.Prisma.CandidateSourceOrderByRelevanceFieldEnum = {
  creditExternal: 'creditExternal'
};

exports.Prisma.CandidateSourceNameOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.CustomSourceCategoryOrderByRelevanceFieldEnum = {
  sourceCategoryName: 'sourceCategoryName',
  externalId: 'externalId'
};

exports.Prisma.CertificateOrLicenseOrderByRelevanceFieldEnum = {
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  searchDescription: 'searchDescription'
};

exports.Prisma.ChatOrderByRelevanceFieldEnum = {
  channelName: 'channelName'
};

exports.Prisma.ChatC2JOrderByRelevanceFieldEnum = {
  chatId: 'chatId'
};

exports.Prisma.CompanyOrderByRelevanceFieldEnum = {
  externalId: 'externalId',
  subdomain: 'subdomain',
  paymentGatewayCustomerId: 'paymentGatewayCustomerId',
  linkedinId: 'linkedinId'
};

exports.Prisma.CompanyDepartmentOrderByRelevanceFieldEnum = {
  departmentName: 'departmentName',
  externalId: 'externalId'
};

exports.Prisma.CompanyInfoOrderByRelevanceFieldEnum = {
  companyName: 'companyName',
  logo: 'logo',
  companyType: 'companyType',
  phoneNumber: 'phoneNumber',
  website: 'website',
  hiringNeeds: 'hiringNeeds',
  atsNeeds: 'atsNeeds',
  currentAtsName: 'currentAtsName',
  reasonToSwitch: 'reasonToSwitch',
  linkedin: 'linkedin',
  linkedinId: 'linkedinId',
  hearAboutUs: 'hearAboutUs'
};

exports.Prisma.CompanyOfficeOrderByRelevanceFieldEnum = {
  officeName: 'officeName',
  externalId: 'externalId'
};

exports.Prisma.CompanyUserOrderByRelevanceFieldEnum = {
  profileImage: 'profileImage'
};

exports.Prisma.ContactInfoOrderByRelevanceFieldEnum = {
  phoneNumber: 'phoneNumber'
};

exports.Prisma.DemographicInfoOrderByRelevanceFieldEnum = {
  raceEthnicity: 'raceEthnicity'
};

exports.Prisma.EducationOrderByRelevanceFieldEnum = {
  institutionName: 'institutionName',
  additionalInformation: 'additionalInformation'
};

exports.Prisma.EmailVerificationOrderByRelevanceFieldEnum = {
  emailAddress: 'emailAddress',
  emailVerificationCode: 'emailVerificationCode'
};

exports.Prisma.CalendarEventOrderByRelevanceFieldEnum = {
  nylasCalendarEventId: 'nylasCalendarEventId',
  title: 'title',
  description: 'description',
  timeZone: 'timeZone',
  location: 'location',
  masterEventId: 'masterEventId',
  nylasConfigurationId: 'nylasConfigurationId'
};

exports.Prisma.EventAttachmentOrderByRelevanceFieldEnum = {
  file: 'file'
};

exports.Prisma.ExperienceOrderByRelevanceFieldEnum = {
  location: 'location',
  longFormDesc: 'longFormDesc',
  searchShortFormDesc: 'searchShortFormDesc',
  searchLongFormDesc: 'searchLongFormDesc',
  subIndustry: 'subIndustry',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  description: 'description'
};

exports.Prisma.JobListingOrderByRelevanceFieldEnum = {
  publicListingId: 'publicListingId',
  externalListingId: 'externalListingId',
  listingTitle: 'listingTitle',
  externalTitle: 'externalTitle',
  publicDescription: 'publicDescription',
  internalMatchingDescription: 'internalMatchingDescription',
  searchPublicDescription: 'searchPublicDescription',
  searchInternalMatchingDescription: 'searchInternalMatchingDescription',
  stateAndOrCountry: 'stateAndOrCountry'
};

exports.Prisma.JobOpeningOrderByRelevanceFieldEnum = {
  extOpeningId: 'extOpeningId'
};

exports.Prisma.JobPipelineOrderByRelevanceFieldEnum = {
  title: 'title'
};

exports.Prisma.JobSeekerHeaderOrderByRelevanceFieldEnum = {
  profileHeadline: 'profileHeadline'
};

exports.Prisma.JobSeekerInfoOrderByRelevanceFieldEnum = {
  messageUserId: 'messageUserId',
  jobLevel: 'jobLevel',
  aboutMe: 'aboutMe'
};

exports.Prisma.JobSeekerSkillOrderByRelevanceFieldEnum = {
  displayName: 'displayName',
  level: 'level'
};

exports.Prisma.CalendarSettingsOrderByRelevanceFieldEnum = {
  timeZone: 'timeZone',
  email: 'email',
  nylasGrantId: 'nylasGrantId'
};

exports.Prisma.ConnectedEmailSettingsOrderByRelevanceFieldEnum = {
  nylasGrantId: 'nylasGrantId',
  email: 'email',
  optOutMessage: 'optOutMessage',
  emailSignature: 'emailSignature'
};

exports.Prisma.EmailConnectionOrderByRelevanceFieldEnum = {
  id: 'id',
  emailRecordId: 'emailRecordId',
  name: 'name',
  emailAddress: 'emailAddress'
};

exports.Prisma.EmailRecordOrderByRelevanceFieldEnum = {
  id: 'id',
  emailThreadId: 'emailThreadId',
  externalEmailId: 'externalEmailId',
  externalThreadId: 'externalThreadId',
  subject: 'subject',
  message: 'message'
};

exports.Prisma.EmailThreadOrderByRelevanceFieldEnum = {
  id: 'id',
  externalThreadId: 'externalThreadId'
};

exports.Prisma.ConnectedEmailOrderByRelevanceFieldEnum = {
  emailId: 'emailId',
  threadId: 'threadId',
  subject: 'subject',
  message: 'message'
};

exports.Prisma.CandidateIncomingEmailOrderByRelevanceFieldEnum = {
  emailId: 'emailId',
  threadId: 'threadId',
  subject: 'subject',
  message: 'message'
};

exports.Prisma.CalendarOrderByRelevanceFieldEnum = {
  name: 'name',
  nylasCalendarId: 'nylasCalendarId',
  color: 'color'
};

exports.Prisma.ProfileDetailsOrderByRelevanceFieldEnum = {
  phoneNumber: 'phoneNumber',
  profileLink: 'profileLink',
  timezone: 'timezone',
  secondaryEmail: 'secondaryEmail'
};

exports.Prisma.CompanyProvidedEmailOrderByRelevanceFieldEnum = {
  email: 'email'
};

exports.Prisma.RejectCandidateQuestionOrderByRelevanceFieldEnum = {
  question: 'question'
};

exports.Prisma.RequisitionOrderByRelevanceFieldEnum = {
  approvalWorkflowJSON: 'approvalWorkflowJSON',
  extRequisitionId: 'extRequisitionId',
  jobName: 'jobName'
};

exports.Prisma.RequisitionJobDescriptionOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.RequisitionSkillOrderByRelevanceFieldEnum = {
  level: 'level',
  displayName: 'displayName'
};

exports.Prisma.ScalisUserOrderByRelevanceFieldEnum = {
  identityProviderId: 'identityProviderId',
  identityProviderUsername: 'identityProviderUsername',
  firstName: 'firstName',
  lastName: 'lastName',
  passwordResetCode: 'passwordResetCode',
  profileImage: 'profileImage',
  stripeCustomerId: 'stripeCustomerId'
};

exports.Prisma.SchedulerLinkInviteOrderByRelevanceFieldEnum = {
  nylasConfigurationId: 'nylasConfigurationId',
  message: 'message'
};

exports.Prisma.ScorecardTemplateOrderByRelevanceFieldEnum = {
  scorecardName: 'scorecardName',
  scorecardDescription: 'scorecardDescription',
  department: 'department'
};

exports.Prisma.ScorecardTemplateQuestionOrderByRelevanceFieldEnum = {
  skillDisplayName: 'skillDisplayName',
  questionText: 'questionText',
  questionDescription: 'questionDescription',
  preferredAnswer: 'preferredAnswer'
};

exports.Prisma.ScorecardTemplateSectionOrderByRelevanceFieldEnum = {
  sectionName: 'sectionName'
};

exports.Prisma.ScreeningQuestionOrderByRelevanceFieldEnum = {
  questionTitle: 'questionTitle',
  questionDesc: 'questionDesc',
  valStatus: 'valStatus',
  ansOptions: 'ansOptions',
  rejectMessage: 'rejectMessage',
  preferredAnswer: 'preferredAnswer'
};

exports.Prisma.ScreeningQuestionAnswerOrderByRelevanceFieldEnum = {
  answer: 'answer'
};

exports.Prisma.ApplicationFormOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.SkillOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.TemplateJobDescriptionOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.TemplateMessageOrderByRelevanceFieldEnum = {
  title: 'title',
  message: 'message',
  emailSubject: 'emailSubject'
};

exports.Prisma.TemplatePipelineOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.TemplateStageOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.CandidateMergeOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.EnrichedLocationOrderByRelevanceFieldEnum = {
  id: 'id',
  location: 'location'
};

exports.Prisma.EnrichedPhoneNumberOrderByRelevanceFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber'
};

exports.Prisma.EnrichedEmailOrderByRelevanceFieldEnum = {
  id: 'id',
  emailAddress: 'emailAddress'
};

exports.Prisma.UploadedCandidateOrderByRelevanceFieldEnum = {
  emailAddress: 'emailAddress',
  firstName: 'firstName',
  lastName: 'lastName',
  linkedinProfile: 'linkedinProfile',
  profileUrl: 'profileUrl',
  profileImage: 'profileImage'
};

exports.Prisma.UploadedCandidateAchievementOrderByRelevanceFieldEnum = {
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  searchDescription: 'searchDescription'
};

exports.Prisma.UploadedCandidateCertificateOrLicenseOrderByRelevanceFieldEnum = {
  name: 'name',
  issuingAuthority: 'issuingAuthority',
  searchDescription: 'searchDescription'
};

exports.Prisma.UploadedCandidateEducationOrderByRelevanceFieldEnum = {
  institutionName: 'institutionName',
  additionalInformation: 'additionalInformation'
};

exports.Prisma.UploadedCandidateExperienceOrderByRelevanceFieldEnum = {
  companyLogo: 'companyLogo',
  location: 'location',
  longFormDesc: 'longFormDesc',
  searchShortFormDesc: 'searchShortFormDesc',
  searchLongFormDesc: 'searchLongFormDesc',
  subIndustry: 'subIndustry',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  description: 'description'
};

exports.Prisma.UploadedCandidateSkillOrderByRelevanceFieldEnum = {
  name: 'name',
  level: 'level'
};

exports.Prisma.UploadedCandidateVolunteerWorkOrderByRelevanceFieldEnum = {
  volunteerJobTitle: 'volunteerJobTitle',
  organizationName: 'organizationName',
  searchDescription: 'searchDescription',
  location: 'location'
};

exports.Prisma.UploadedCandidateWebsiteOrSocialMediaOrderByRelevanceFieldEnum = {
  websiteURL: 'websiteURL'
};

exports.Prisma.UploadedDocumentOrderByRelevanceFieldEnum = {
  documentPath: 'documentPath',
  documentName: 'documentName'
};

exports.Prisma.ScalisUserUploadedDocumentOrderByRelevanceFieldEnum = {
  documentPath: 'documentPath',
  documentName: 'documentName'
};

exports.Prisma.UserInvitationOrderByRelevanceFieldEnum = {
  verificationCode: 'verificationCode',
  email: 'email'
};

exports.Prisma.VolunteerWorkOrderByRelevanceFieldEnum = {
  volunteerJobTitle: 'volunteerJobTitle',
  organizationName: 'organizationName',
  searchDescription: 'searchDescription',
  location: 'location'
};

exports.Prisma.WebsiteOrSocialMediaOrderByRelevanceFieldEnum = {
  websiteURL: 'websiteURL'
};

exports.Prisma.ExternalJobApplicationOrderByRelevanceFieldEnum = {
  jobId: 'jobId',
  jobTitle: 'jobTitle',
  employerName: 'employerName',
  jobUrl: 'jobUrl',
  location: 'location'
};

exports.Prisma.JobAdCampaignOrderByRelevanceFieldEnum = {
  vonqCampaignId: 'vonqCampaignId',
  campaignName: 'campaignName'
};

exports.Prisma.OrderOrderByRelevanceFieldEnum = {
  orderReference: 'orderReference'
};

exports.Prisma.AiFeatureUsageOrderByRelevanceFieldEnum = {
  featureName: 'featureName'
};

exports.Prisma.UserSubscriptionOrderByRelevanceFieldEnum = {
  stripeCustomerId: 'stripeCustomerId',
  subscriptionId: 'subscriptionId',
  productId: 'productId'
};

exports.Prisma.CandidateOfferVersionOrderByRelevanceFieldEnum = {
  candidateName: 'candidateName',
  jobTitle: 'jobTitle',
  manager: 'manager',
  signatureRequestId: 'signatureRequestId'
};

exports.Prisma.CandidateOfferVersionSignatureOrderByRelevanceFieldEnum = {
  emailAddress: 'emailAddress',
  name: 'name',
  externalId: 'externalId',
  externalStatus: 'externalStatus'
};

exports.Prisma.CandidateOfferFileOrderByRelevanceFieldEnum = {
  filePath: 'filePath',
  fileName: 'fileName'
};

exports.Prisma.DefaultTokenOrderByRelevanceFieldEnum = {
  tableName: 'tableName',
  columnName: 'columnName'
};

exports.Prisma.OfferDocumentTemplateOrderByRelevanceFieldEnum = {
  documentTemplateText: 'documentTemplateText',
  documentTemplateName: 'documentTemplateName',
  documentFilePath: 'documentFilePath',
  documentFileName: 'documentFileName'
};

exports.Prisma.OfferSectionTemplateOrderByRelevanceFieldEnum = {
  sectionTemplateName: 'sectionTemplateName',
  tokenDescription: 'tokenDescription',
  sectionToken: 'sectionToken',
  sectionTemplateText: 'sectionTemplateText'
};

exports.Prisma.OfferCustomFieldOrderByRelevanceFieldEnum = {
  fieldName: 'fieldName',
  fieldDescription: 'fieldDescription',
  systemTokenName: 'systemTokenName'
};

exports.Prisma.CandidateOfferRejectionOrderByRelevanceFieldEnum = {
  reason: 'reason'
};

exports.Prisma.CandidateApplicationStatusOrderByRelevanceFieldEnum = {
  source: 'source'
};

exports.Prisma.ScheduledReportOrderByRelevanceFieldEnum = {
  taskId: 'taskId',
  cronExpression: 'cronExpression',
  customTime: 'customTime'
};

exports.Prisma.SharedCoreReportOrderByRelevanceFieldEnum = {
  email: 'email'
};

exports.Prisma.CoreReportFilterOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.JobListingVectorsOrderByRelevanceFieldEnum = {
  content: 'content'
};

exports.Prisma.CompanyUserGroupOrderByRelevanceFieldEnum = {
  name: 'name',
  externalId: 'externalId'
};

exports.Prisma.CompanySavedViewOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.TalentPoolOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.CandidateFilterOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.JobSearchPreferenceOrderByRelevanceFieldEnum = {
  minimumPayPreference: 'minimumPayPreference',
  minimumRequiredExperience: 'minimumRequiredExperience',
  maxRequiredExperience: 'maxRequiredExperience'
};

exports.Prisma.ApprovalWorkflowOrderByRelevanceFieldEnum = {
  uniqueId: 'uniqueId',
  workflowJSON: 'workflowJSON'
};

exports.Prisma.CandidateLabelOrderByRelevanceFieldEnum = {
  labelName: 'labelName'
};

exports.Prisma.TalentPoolTagOrderByRelevanceFieldEnum = {
  tagName: 'tagName'
};

exports.Prisma.TalentPoolProspectStatusOrderByRelevanceFieldEnum = {
  status: 'status'
};

exports.Prisma.CustomApplicationStatusOrderByRelevanceFieldEnum = {
  applicationStatusName: 'applicationStatusName',
  colorHexCode: 'colorHexCode',
  iconUnicode: 'iconUnicode'
};

exports.Prisma.CustomCandidateProfileFieldOrderByRelevanceFieldEnum = {
  name: 'name',
  tooltipText: 'tooltipText',
  systemTokenName: 'systemTokenName'
};

exports.Prisma.CustomCandidateProfileFieldValueOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CustomCandidateApplicationFieldOrderByRelevanceFieldEnum = {
  name: 'name',
  tooltipText: 'tooltipText',
  systemTokenName: 'systemTokenName'
};

exports.Prisma.CustomCandidateApplicationFieldValueOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.SequenceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  archivedReason: 'archivedReason'
};

exports.Prisma.FavoriteSequenceOrderByRelevanceFieldEnum = {
  sequenceId: 'sequenceId'
};

exports.Prisma.SequenceSettingOrderByRelevanceFieldEnum = {
  unsubscribeLinkText: 'unsubscribeLinkText'
};

exports.Prisma.SequenceScheduleSettingOrderByRelevanceFieldEnum = {
  name: 'name',
  timeZone: 'timeZone',
  startTime: 'startTime',
  endTime: 'endTime'
};

exports.Prisma.SequenceStepOrderByRelevanceFieldEnum = {
  sequenceId: 'sequenceId',
  customSendTime: 'customSendTime',
  subject: 'subject',
  body: 'body'
};

exports.Prisma.SequenceAssociatedRequisitionOrderByRelevanceFieldEnum = {
  sequenceId: 'sequenceId'
};

exports.Prisma.SequenceAssociatedTalentPoolOrderByRelevanceFieldEnum = {
  sequenceId: 'sequenceId'
};

exports.Prisma.SequenceCandidateOrderByRelevanceFieldEnum = {
  sequenceId: 'sequenceId',
  optOutToken: 'optOutToken'
};

exports.Prisma.SequenceActivityLogOrderByRelevanceFieldEnum = {
  emailRecordId: 'emailRecordId'
};

exports.Prisma.ApprovalWorkflowVersionOrderByRelevanceFieldEnum = {
  externalId: 'externalId'
};

exports.Prisma.ApprovalReviewerStatusOrderByRelevanceFieldEnum = {
  comments: 'comments'
};

exports.Prisma.TemplateApprovalWorkflowOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.CustomJobRequisitionFieldOrderByRelevanceFieldEnum = {
  name: 'name',
  tooltipText: 'tooltipText',
  systemTokenName: 'systemTokenName'
};

exports.Prisma.CustomJobRequisitionFieldValueOrderByRelevanceFieldEnum = {
  value: 'value'
};

exports.Prisma.CompanyGlobalOrderByRelevanceFieldEnum = {
  name: 'name',
  headquarters: 'headquarters',
  website: 'website',
  lastFundingRound: 'lastFundingRound',
  logo: 'logo',
  externalId: 'externalId'
};

exports.Prisma.CompanyTagsOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.IntegrationsNylasNotetakerOrderByRelevanceFieldEnum = {
  nylasNotetakerId: 'nylasNotetakerId',
  summary: 'summary',
  transcriptPath: 'transcriptPath',
  recordingPath: 'recordingPath'
};

exports.Prisma.InterviewerPoolOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description'
};

exports.Prisma.InterviewTemplateOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.InterviewTemplateLoopOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.CandidateInterviewLoopOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.CandidateAvailabilityRequestOrderByRelevanceFieldEnum = {
  candidateName: 'candidateName',
  interviewTitle: 'interviewTitle',
  timeZone: 'timeZone',
  notes: 'notes'
};
exports.UserActionEnum = exports.$Enums.UserActionEnum = {
  ADVANCE_CANDIDATE: 'ADVANCE_CANDIDATE',
  APPLICATION_WITHDRAWN: 'APPLICATION_WITHDRAWN',
  AVAILABILITY_SUBMITTED: 'AVAILABILITY_SUBMITTED',
  CANDIDATE_APPLIED: 'CANDIDATE_APPLIED',
  CANDIDATE_DETAILS_UPDATED: 'CANDIDATE_DETAILS_UPDATED',
  CANDIDATE_RATING_SUBMITTED: 'CANDIDATE_RATING_SUBMITTED',
  CANDIDATE_RATING_UPDATED: 'CANDIDATE_RATING_UPDATED',
  CANDIDATE_UPLOADED: 'CANDIDATE_UPLOADED',
  CANDIDATE_MARK_AS_PRIMARY: 'CANDIDATE_MARK_AS_PRIMARY',
  CANDIDATE_MARK_AS_DUPLICATE: 'CANDIDATE_MARK_AS_DUPLICATE',
  EMAIL_CANDIDATE: 'EMAIL_CANDIDATE',
  INTERVIEW_CONFIRMATION_SENT: 'INTERVIEW_CONFIRMATION_SENT',
  INTERVIEW_SCHEDULED_LINK: 'INTERVIEW_SCHEDULED_LINK',
  INTERVIEW_SCHEDULED_MANUALLY: 'INTERVIEW_SCHEDULED_MANUALLY',
  INVITE_CANDIDATE: 'INVITE_CANDIDATE',
  INVITE_EXPIRED: 'INVITE_EXPIRED',
  INVITE_REJECTED: 'INVITE_REJECTED',
  MARK_INTERVIEW_COMPLETE: 'MARK_INTERVIEW_COMPLETE',
  MATCH_CANDIDATE: 'MATCH_CANDIDATE',
  OFFER_ACCEPTED_BY_CANDIDATE: 'OFFER_ACCEPTED_BY_CANDIDATE',
  OFFER_CREATED: 'OFFER_CREATED',
  OFFER_DECLINED_BY_CANDIDATE: 'OFFER_DECLINED_BY_CANDIDATE',
  OFFER_DELETED: 'OFFER_DELETED',
  OFFER_NEW_VERSION_CREATED: 'OFFER_NEW_VERSION_CREATED',
  OFFER_SENT_TO_CANDIDATE: 'OFFER_SENT_TO_CANDIDATE',
  OFFER_SENT_TO_CANDIDATE_AWAITING_SIGNATURE: 'OFFER_SENT_TO_CANDIDATE_AWAITING_SIGNATURE',
  OFFER_VOIDED: 'OFFER_VOIDED',
  REFERRED_CANDIDATE: 'REFERRED_CANDIDATE',
  REJECT_CANDIDATE: 'REJECT_CANDIDATE',
  REJECTION_CANCELLED: 'REJECTION_CANCELLED',
  REJECTION_PENDING: 'REJECTION_PENDING',
  REMOVE_CANDIDATE: 'REMOVE_CANDIDATE',
  REQUEST_AVAILABILITY: 'REQUEST_AVAILABILITY',
  RETURN_CANDIDATE_TO_PREVIOUS_STAGE: 'RETURN_CANDIDATE_TO_PREVIOUS_STAGE',
  SCORECARD_COMPLETE: 'SCORECARD_COMPLETE',
  SCORECARD_CREATED: 'SCORECARD_CREATED',
  SCORECARD_EDITED: 'SCORECARD_EDITED',
  SCORECARD_IN_PROGRESS: 'SCORECARD_IN_PROGRESS',
  SEND_SCHEDULER_LINK: 'SEND_SCHEDULER_LINK',
  UNMARK_INTERVIEW_COMPLETE: 'UNMARK_INTERVIEW_COMPLETE',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
  JOB_OFFER_APPROVAL_REQUESTED: 'JOB_OFFER_APPROVAL_REQUESTED',
  JOB_OFFER_APPROVED: 'JOB_OFFER_APPROVED',
  JOB_OFFER_APPROVAL_DENIED: 'JOB_OFFER_APPROVAL_DENIED',
  JOB_APPROVAL_REQUESTED: 'JOB_APPROVAL_REQUESTED',
  JOB_APPROVED: 'JOB_APPROVED',
  JOB_APPROVAL_DENIED: 'JOB_APPROVAL_DENIED',
  JOB_OPENING_APPROVAL_REQUESTED: 'JOB_OPENING_APPROVAL_REQUESTED',
  JOB_OPENING_APPROVED: 'JOB_OPENING_APPROVED',
  JOB_OPENING_APPROVAL_DENIED: 'JOB_OPENING_APPROVAL_DENIED',
  JOB_DETAILS_UPDATED: 'JOB_DETAILS_UPDATED',
  JOB_OPENING_UPDATED: 'JOB_OPENING_UPDATED',
  JOB_LISTING_UPDATED: 'JOB_LISTING_UPDATED'
};

exports.JobActionEnum = exports.$Enums.JobActionEnum = {
  CREATED: 'CREATED',
  JOB_OPENED: 'JOB_OPENED',
  JOB_CLOSED: 'JOB_CLOSED',
  JOB_ON_HOLD: 'JOB_ON_HOLD',
  JOB_OPENING_DELETED: 'JOB_OPENING_DELETED',
  JOB_OPENING_OPENED: 'JOB_OPENING_OPENED',
  JOB_OPENING_FILLED: 'JOB_OPENING_FILLED',
  JOB_OPENING_CLOSED: 'JOB_OPENING_CLOSED',
  JOB_OPENING_ON_HOLD: 'JOB_OPENING_ON_HOLD',
  JOB_OPENING_APPROVED: 'JOB_OPENING_APPROVED',
  JOB_OPENING_APPROVAL_REQUESTED: 'JOB_OPENING_APPROVAL_REQUESTED',
  JOB_OPENING_DENIED: 'JOB_OPENING_DENIED',
  JOB_APPROVED: 'JOB_APPROVED',
  JOB_APPROVAL_REQUESTED: 'JOB_APPROVAL_REQUESTED',
  JOB_DENIED: 'JOB_DENIED',
  JOB_OFFER_APPROVAL_REQUESTED: 'JOB_OFFER_APPROVAL_REQUESTED',
  JOB_OFFER_APPROVED: 'JOB_OFFER_APPROVED',
  JOB_OFFER_APPROVAL_DENIED: 'JOB_OFFER_APPROVAL_DENIED'
};

exports.AddressTypeEnum = exports.$Enums.AddressTypeEnum = {
  PROFILE_ADDRESS: 'PROFILE_ADDRESS',
  COMPANY_ADDRESS: 'COMPANY_ADDRESS',
  COMPANY_BILLING_ADDRESS: 'COMPANY_BILLING_ADDRESS',
  SCALIS_USER_BILLING_ADDRESS: 'SCALIS_USER_BILLING_ADDRESS'
};

exports.RejectionReasonEnum = exports.$Enums.RejectionReasonEnum = {
  BETTER_QUALIFIED_CANDIDATES_CHOSEN_EDUCATION: 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_EDUCATION',
  BETTER_QUALIFIED_CANDIDATES_CHOSEN_SKILLS: 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_SKILLS',
  BETTER_QUALIFIED_CANDIDATES_CHOSEN_EXPERIENCE: 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_EXPERIENCE',
  CANDIDATE_APPLIED_TO_WRONG_POSITION: 'CANDIDATE_APPLIED_TO_WRONG_POSITION',
  CANDIDATE_WITHDRAWN: 'CANDIDATE_WITHDRAWN',
  DECLINED_INTERVIEW: 'DECLINED_INTERVIEW',
  DOESNT_MEET_MINIMUM_QUALIFICATIONS: 'DOESNT_MEET_MINIMUM_QUALIFICATIONS',
  DUPLICATE_APPLICATION: 'DUPLICATE_APPLICATION',
  FAILED_ASSESSMENT: 'FAILED_ASSESSMENT',
  FAILED_BACKGROUND_CHECK: 'FAILED_BACKGROUND_CHECK',
  FAILED_DRUG_TEST: 'FAILED_DRUG_TEST',
  FAILED_TO_COMPLETE_REQUIRED_ASSESSMENT: 'FAILED_TO_COMPLETE_REQUIRED_ASSESSMENT',
  FAILED_TO_RESPOND: 'FAILED_TO_RESPOND',
  IMPRACTICAL_JOB_EXPECTATIONS: 'IMPRACTICAL_JOB_EXPECTATIONS',
  INFLATED_RESPONSIBILITIES: 'INFLATED_RESPONSIBILITIES',
  INTERVIEW_NO_SHOW: 'INTERVIEW_NO_SHOW',
  JOB_NOT_ALIGNED_WITH_CAREER_OBJECTIVES: 'JOB_NOT_ALIGNED_WITH_CAREER_OBJECTIVES',
  LACK_OF_RELEVANT_EXPERIENCE: 'LACK_OF_RELEVANT_EXPERIENCE',
  LACK_OF_RELEVANT_SKILLS_AND_ABILITIES: 'LACK_OF_RELEVANT_SKILLS_AND_ABILITIES',
  LACKED_CLARITY_IN_ANSWERS: 'LACKED_CLARITY_IN_ANSWERS',
  LACKED_SPECIFIC_TECHNICAL_KNOWLEDGE: 'LACKED_SPECIFIC_TECHNICAL_KNOWLEDGE',
  LIMITED_AVAILABILITY_OR_SCHEDULING_CONFLICTS: 'LIMITED_AVAILABILITY_OR_SCHEDULING_CONFLICTS',
  MISSING_REQUIRED_CERTIFICATIONS: 'MISSING_REQUIRED_CERTIFICATIONS',
  NEGATIVE_REFERENCES: 'NEGATIVE_REFERENCES',
  OFFER_REJECTED_DOESNT_MEET_SALARY_EXPECTATIONS: 'OFFER_REJECTED_DOESNT_MEET_SALARY_EXPECTATIONS',
  OFFER_REJECTED_JOB_LOCATION: 'OFFER_REJECTED_JOB_LOCATION',
  OFFER_REJECTED_JOB_SCHEDULE: 'OFFER_REJECTED_JOB_SCHEDULE',
  OFFER_REJECTED_OTHER: 'OFFER_REJECTED_OTHER',
  OTHER: 'OTHER',
  OVERQUALIFIED_FOR_POSITION: 'OVERQUALIFIED_FOR_POSITION',
  POOR_COMMUNICATION_SKILLS: 'POOR_COMMUNICATION_SKILLS',
  POOR_INTERVIEW_PERFORMANCE: 'POOR_INTERVIEW_PERFORMANCE',
  POSITION_ALREADY_FILLED: 'POSITION_ALREADY_FILLED',
  POSITION_ELIMINATED: 'POSITION_ELIMINATED',
  POSITION_ON_HOLD: 'POSITION_ON_HOLD',
  REQUIRES_VISA_SPONSORSHIP: 'REQUIRES_VISA_SPONSORSHIP',
  SALARY_EXPECTATIONS_TOO_HIGH: 'SALARY_EXPECTATIONS_TOO_HIGH',
  UNABLE_TO_RELOCATE_AS_REQUIRED: 'UNABLE_TO_RELOCATE_AS_REQUIRED',
  UNPROFESSIONAL_BEHAVIOR_DURING_HIRING_PROCESS: 'UNPROFESSIONAL_BEHAVIOR_DURING_HIRING_PROCESS'
};

exports.ApplicationTypeEnum = exports.$Enums.ApplicationTypeEnum = {
  STATIC: 'STATIC',
  DYNAMIC: 'DYNAMIC'
};

exports.ApplicationStatusEnum = exports.$Enums.ApplicationStatusEnum = {
  PROSPECT: 'PROSPECT',
  INVITED_TO_APPLY: 'INVITED_TO_APPLY',
  INVITE_DECLINED: 'INVITE_DECLINED',
  INTERVIEW_NOT_SCHEDULED: 'INTERVIEW_NOT_SCHEDULED',
  INTERVIEW_REQUESTED: 'INTERVIEW_REQUESTED',
  INTERVIEW_RESEND: 'INTERVIEW_RESEND',
  INTERVIEW_SCHEDULED: 'INTERVIEW_SCHEDULED',
  INTERVIEW_COMPLETED: 'INTERVIEW_COMPLETED',
  REJECTED: 'REJECTED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  REJECTION_PENDING: 'REJECTION_PENDING',
  REJECTION_CANCELLED: 'REJECTION_CANCELLED',
  CUSTOM: 'CUSTOM'
};

exports.ApplicationCreationTypeEnum = exports.$Enums.ApplicationCreationTypeEnum = {
  DUMMY: 'DUMMY'
};

exports.InterviewSchedulingEnum = exports.$Enums.InterviewSchedulingEnum = {
  SEND_INVITE: 'SEND_INVITE',
  MANUALLY_SCHEDULE: 'MANUALLY_SCHEDULE'
};

exports.CandidateApplicationDuplicationStatusEnum = exports.$Enums.CandidateApplicationDuplicationStatusEnum = {
  DUPLICATE: 'DUPLICATE',
  HIDDEN: 'HIDDEN',
  PRIMARY: 'PRIMARY'
};

exports.CandidateInterviewStatusEnum = exports.$Enums.CandidateInterviewStatusEnum = {
  INTERVIEW_NOT_SCHEDULED: 'INTERVIEW_NOT_SCHEDULED',
  INTERVIEW_SCHEDULED: 'INTERVIEW_SCHEDULED',
  INTERVIEW_COMPLETED: 'INTERVIEW_COMPLETED',
  INTERVIEW_RESEND: 'INTERVIEW_RESEND',
  INTERVIEW_REQUESTED: 'INTERVIEW_REQUESTED'
};

exports.InterviewStatusEnum = exports.$Enums.InterviewStatusEnum = {
  NOT_SCHEDULED: 'NOT_SCHEDULED',
  AWAITING_AVAILABILITY: 'AWAITING_AVAILABILITY',
  AVAILABILITY_RECEIVED: 'AVAILABILITY_RECEIVED',
  SCHEDULED: 'SCHEDULED',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED',
  COMPLETE: 'COMPLETE',
  COMPLETE_PENDING_FEEDBACK: 'COMPLETE_PENDING_FEEDBACK',
  COMPLETE_FEEDBACK_SUBMITTED: 'COMPLETE_FEEDBACK_SUBMITTED',
  NO_SHOW_CANDIDATE: 'NO_SHOW_CANDIDATE'
};

exports.SchedulingLogicEnum = exports.$Enums.SchedulingLogicEnum = {
  ONE_ON_ONE: 'ONE_ON_ONE',
  PANEL: 'PANEL',
  LOOP: 'LOOP',
  SELF_SCHEDULING: 'SELF_SCHEDULING'
};

exports.ProfileTypeEnum = exports.$Enums.ProfileTypeEnum = {
  JOB_SEEKER: 'JOB_SEEKER',
  UPLOADED_CANDIDATE: 'UPLOADED_CANDIDATE'
};

exports.ScorecardStatusEnum = exports.$Enums.ScorecardStatusEnum = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
};

exports.OverallRecommendationEnum = exports.$Enums.OverallRecommendationEnum = {
  YES: 'YES',
  NO: 'NO',
  NEUTRAL: 'NEUTRAL'
};

exports.SourceCategoryEnum = exports.$Enums.SourceCategoryEnum = {
  SOURCED: 'SOURCED',
  THIRD_PARTY: 'THIRD_PARTY',
  AGENCY: 'AGENCY',
  COMPANY_WEBSITE: 'COMPANY_WEBSITE',
  DIRECT_APPLICANT: 'DIRECT_APPLICANT',
  REFERRED: 'REFERRED',
  UNIVERSITY: 'UNIVERSITY',
  INTERNAL: 'INTERNAL',
  EVENT: 'EVENT',
  OTHER: 'OTHER',
  SCALIS: 'SCALIS',
  CUSTOM: 'CUSTOM'
};

exports.CurrencyEnum = exports.$Enums.CurrencyEnum = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP'
};

exports.CompanyDepartmentTypeEnum = exports.$Enums.CompanyDepartmentTypeEnum = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM'
};

exports.IndustryEnum = exports.$Enums.IndustryEnum = {
  AEROSPACE_AND_DEFENSE: 'AEROSPACE_AND_DEFENSE',
  AGRICULTURE: 'AGRICULTURE',
  ARTS_ENTERTAINMENT_AND_RECREATION: 'ARTS_ENTERTAINMENT_AND_RECREATION',
  AUTOMOTIVE: 'AUTOMOTIVE',
  CONSTRUCTION: 'CONSTRUCTION',
  CONSULTING_SERVICES: 'CONSULTING_SERVICES',
  EDUCATION: 'EDUCATION',
  E_COMMERCE: 'E_COMMERCE',
  ENERGY_MINING_AND_UTILITIES: 'ENERGY_MINING_AND_UTILITIES',
  ENVIRONMENTAL_SERVICES: 'ENVIRONMENTAL_SERVICES',
  FASHION_AND_APPAREL: 'FASHION_AND_APPAREL',
  FINANCIAL_SERVICES: 'FINANCIAL_SERVICES',
  FOOD_AND_BEVERAGE: 'FOOD_AND_BEVERAGE',
  GOVERNMENT_AND_PUBLIC_ADMINSTRATION: 'GOVERNMENT_AND_PUBLIC_ADMINSTRATION',
  HEALTHCARE: 'HEALTHCARE',
  HOTELS_AND_TRAVEL_ACCOMODATION: 'HOTELS_AND_TRAVEL_ACCOMODATION',
  HUMAN_RESOURCES_AND_STAFFING: 'HUMAN_RESOURCES_AND_STAFFING',
  INFORMATION_TECHNOLOGY: 'INFORMATION_TECHNOLOGY',
  INSURANCE: 'INSURANCE',
  LEGAL: 'LEGAL',
  MANAGEMENT_AND_CONSULTING: 'MANAGEMENT_AND_CONSULTING',
  MANUFACTURING: 'MANUFACTURING',
  MEDIA_AND_COMMUNICATION: 'MEDIA_AND_COMMUNICATION',
  NONPROFIT_AND_NGO: 'NONPROFIT_AND_NGO',
  PERSONAL_CONSUMER_SERVICES: 'PERSONAL_CONSUMER_SERVICES',
  PHARMACEUTICAL_AND_BIOTECH: 'PHARMACEUTICAL_AND_BIOTECH',
  PROFESSIONAL_SERVICES: 'PROFESSIONAL_SERVICES',
  REAL_ESTATE: 'REAL_ESTATE',
  RESTAURANTS_AND_FOOD_SERVICE: 'RESTAURANTS_AND_FOOD_SERVICE',
  RETAIL_AND_WHOLESALE: 'RETAIL_AND_WHOLESALE',
  SOCIAL_MEDIA_AND_NETWORKING: 'SOCIAL_MEDIA_AND_NETWORKING',
  TELECOMMUNICATIONS: 'TELECOMMUNICATIONS',
  TRANSPORTATION_AND_LOGISTICS: 'TRANSPORTATION_AND_LOGISTICS'
};

exports.SubIndustryEnum = exports.$Enums.SubIndustryEnum = {
  AERO_DEFENSE_AVIATION_SERVICES: 'AERO_DEFENSE_AVIATION_SERVICES',
  AGRI_ANIMAL_PRODUCTION: 'AGRI_ANIMAL_PRODUCTION',
  AGRI_CROP_PRODUCTION: 'AGRI_CROP_PRODUCTION',
  AGRI_FARM_SUPPORT: 'AGRI_FARM_SUPPORT',
  AGRI_FISHERY: 'AGRI_FISHERY',
  AGRI_FLORAL_NURSERY: 'AGRI_FLORAL_NURSERY',
  AGRI_FORESTRY_LOGGING_TIMBER: 'AGRI_FORESTRY_LOGGING_TIMBER',
  ARTS_ENT_REC_ART_GALLERIES: 'ARTS_ENT_REC_ART_GALLERIES',
  ARTS_ENT_REC_CULTURE_ENTERTAINMENT: 'ARTS_ENT_REC_CULTURE_ENTERTAINMENT',
  ARTS_ENT_REC_FILM_PRODUCTION: 'ARTS_ENT_REC_FILM_PRODUCTION',
  ARTS_ENT_REC_GAMBLING: 'ARTS_ENT_REC_GAMBLING',
  ARTS_ENT_REC_PHOTOGRAPHY: 'ARTS_ENT_REC_PHOTOGRAPHY',
  ARTS_ENT_REC_PUBLISHING: 'ARTS_ENT_REC_PUBLISHING',
  ARTS_ENT_REC_MUSIC_SOUND_PRODUCTION: 'ARTS_ENT_REC_MUSIC_SOUND_PRODUCTION',
  ARTS_ENT_REC_SPORTS_RECREATION: 'ARTS_ENT_REC_SPORTS_RECREATION',
  ARTS_ENT_REC_TICKET_SALES: 'ARTS_ENT_REC_TICKET_SALES',
  ARTS_ENT_REC_TRANSLATION_LINGUISTIC: 'ARTS_ENT_REC_TRANSLATION_LINGUISTIC',
  ARTS_ENT_REC_VIDEO_GAME_PUBLISHING: 'ARTS_ENT_REC_VIDEO_GAME_PUBLISHING',
  AUTO_VEHICLE_DEALERS: 'AUTO_VEHICLE_DEALERS',
  AUTO_VEHICLE_MANUFACTURING: 'AUTO_VEHICLE_MANUFACTURING',
  AUTO_VEHICLE_REPAIR_MAINTENANCE: 'AUTO_VEHICLE_REPAIR_MAINTENANCE',
  AUTO_ELECTRIC_VEHICLE_MANUFACTURING: 'AUTO_ELECTRIC_VEHICLE_MANUFACTURING',
  CONSTR_ARCHITECTURAL_ENGINEERING: 'CONSTR_ARCHITECTURAL_ENGINEERING',
  CONSTR_COMMERCIAL_EQUIPMENT: 'CONSTR_COMMERCIAL_EQUIPMENT',
  CONSTR_REPAIR_FACILITIES: 'CONSTR_REPAIR_FACILITIES',
  CONSULT_CFO_CONSULTING: 'CONSULT_CFO_CONSULTING',
  CONSULT_HR_CONSULTING: 'CONSULT_HR_CONSULTING',
  CONSULT_MARKETING_CONSULTING: 'CONSULT_MARKETING_CONSULTING',
  CONSULT_SALES_CONSULTING: 'CONSULT_SALES_CONSULTING',
  CONSULT_STRATEGY_CONSULTING: 'CONSULT_STRATEGY_CONSULTING',
  EDU_COLLEGES_UNIVERSITIES: 'EDU_COLLEGES_UNIVERSITIES',
  EDU_TRAINING_SERVICES: 'EDU_TRAINING_SERVICES',
  EDU_SOFTWARE: 'EDU_SOFTWARE',
  EDU_LMS: 'EDU_LMS',
  EDU_ONLINE_PLATFORMS: 'EDU_ONLINE_PLATFORMS',
  EDU_PRESCHOOLS_CHILDCARE: 'EDU_PRESCHOOLS_CHILDCARE',
  EDU_PRIMARY_SECONDARY: 'EDU_PRIMARY_SECONDARY',
  ECOM_LOGISTICS_FULFILLMENT: 'ECOM_LOGISTICS_FULFILLMENT',
  ECOM_ONLINE_MARKETPLACE: 'ECOM_ONLINE_MARKETPLACE',
  ECOM_ONLINE_PAYMENTS: 'ECOM_ONLINE_PAYMENTS',
  ECOM_SAAS: 'ECOM_SAAS',
  ECOM_AGENCY: 'ECOM_AGENCY',
  ECOM_BRAND: 'ECOM_BRAND',
  ENERGY_UTILITIES: 'ENERGY_UTILITIES',
  ENERGY_MINING_METALS: 'ENERGY_MINING_METALS',
  ENERGY_RENEWABLE: 'ENERGY_RENEWABLE',
  ENV_SVCS_ENV_CONSULTING: 'ENV_SVCS_ENV_CONSULTING',
  ENV_SVCS_RENEWABLE_ENERGY: 'ENV_SVCS_RENEWABLE_ENERGY',
  ENV_SVCS_WASTE_MANAGEMENT: 'ENV_SVCS_WASTE_MANAGEMENT',
  FASHION_CLOTHING_RETAILERS: 'FASHION_CLOTHING_RETAILERS',
  FASHION_DESIGNERS: 'FASHION_DESIGNERS',
  FASHION_TEXTILE_FABRIC: 'FASHION_TEXTILE_FABRIC',
  FIN_SVCS_ACCOUNTING_TAX: 'FIN_SVCS_ACCOUNTING_TAX',
  FIN_SVCS_BANKING_LENDING: 'FIN_SVCS_BANKING_LENDING',
  FIN_SVCS_DEBT_RELIEF: 'FIN_SVCS_DEBT_RELIEF',
  FIN_SVCS_DIGITAL_PAYMENTS: 'FIN_SVCS_DIGITAL_PAYMENTS',
  FIN_SVCS_PLANNING_ADVISORY: 'FIN_SVCS_PLANNING_ADVISORY',
  FIN_SVCS_TRANSACTION_PROCESSING: 'FIN_SVCS_TRANSACTION_PROCESSING',
  FIN_SVCS_ASSET_MANAGEMENT: 'FIN_SVCS_ASSET_MANAGEMENT',
  FIN_SVCS_P2P_LENDING: 'FIN_SVCS_P2P_LENDING',
  FIN_SVCS_ROBO_ADVISORY: 'FIN_SVCS_ROBO_ADVISORY',
  FIN_SVCS_STOCK_EXCHANGES: 'FIN_SVCS_STOCK_EXCHANGES',
  FOOD_BEV_BEVERAGE_PRODUCTION: 'FOOD_BEV_BEVERAGE_PRODUCTION',
  FOOD_BEV_DELIVERY: 'FOOD_BEV_DELIVERY',
  FOOD_BEV_ORGANIC_NATURAL: 'FOOD_BEV_ORGANIC_NATURAL',
  GOV_PUBLIC_ADMIN_MUNICIPAL: 'GOV_PUBLIC_ADMIN_MUNICIPAL',
  GOV_PUBLIC_ADMIN_NATIONAL: 'GOV_PUBLIC_ADMIN_NATIONAL',
  GOV_PUBLIC_ADMIN_STATE_REGIONAL: 'GOV_PUBLIC_ADMIN_STATE_REGIONAL',
  HEALTH_AMBULANCE_MEDICAL_TRANSPORT: 'HEALTH_AMBULANCE_MEDICAL_TRANSPORT',
  HEALTH_DENTAL_CLINICS: 'HEALTH_DENTAL_CLINICS',
  HEALTH_TECH: 'HEALTH_TECH',
  HEALTH_HOME_CARE: 'HEALTH_HOME_CARE',
  HEALTH_HOSPITALS_CLINICS: 'HEALTH_HOSPITALS_CLINICS',
  HEALTH_MED_EQUIP_SUPPLIES: 'HEALTH_MED_EQUIP_SUPPLIES',
  HEALTH_MED_TESTING_LABS: 'HEALTH_MED_TESTING_LABS',
  HEALTH_NURSING_CARE: 'HEALTH_NURSING_CARE',
  HEALTH_REHAB_SERVICES: 'HEALTH_REHAB_SERVICES',
  HOTELS_TRAVEL_CRUISE_LINES: 'HOTELS_TRAVEL_CRUISE_LINES',
  HOTELS_TRAVEL_EVENT_MANAGEMENT: 'HOTELS_TRAVEL_EVENT_MANAGEMENT',
  HOTELS_TRAVEL_HOTELS_RESORTS: 'HOTELS_TRAVEL_HOTELS_RESORTS',
  HOTELS_TRAVEL_THEME_PARKS: 'HOTELS_TRAVEL_THEME_PARKS',
  HOTELS_TRAVEL_AGENCIES: 'HOTELS_TRAVEL_AGENCIES',
  HUMANRES_STAFFING_HR_CONSULTING: 'HUMANRES_STAFFING_HR_CONSULTING',
  HUMANRES_STAFFING_STAFFING_SUBCONTRACTING: 'HUMANRES_STAFFING_STAFFING_SUBCONTRACTING',
  INFO_CLOUD_COMPUTING: 'INFO_CLOUD_COMPUTING',
  INFO_HARDWARE_DEV: 'INFO_HARDWARE_DEV',
  INFO_CYBERSECURITY: 'INFO_CYBERSECURITY',
  INFO_DATA_ANALYTICS: 'INFO_DATA_ANALYTICS',
  INFO_SUPPORT_SERVICES: 'INFO_SUPPORT_SERVICES',
  INFO_WEB_SERVICES: 'INFO_WEB_SERVICES',
  INFO_SAAS: 'INFO_SAAS',
  INFO_SOFTWARE_DEV: 'INFO_SOFTWARE_DEV',
  INFO_TELECOM_EQUIP: 'INFO_TELECOM_EQUIP',
  INS_HEALTH_INSURANCE: 'INS_HEALTH_INSURANCE',
  INS_AGENCIES_BROKERAGES: 'INS_AGENCIES_BROKERAGES',
  INS_CARRIERS: 'INS_CARRIERS',
  LEGAL_LAW_FIRMS: 'LEGAL_LAW_FIRMS',
  LEGAL_SERVICES: 'LEGAL_SERVICES',
  MANAGE_BUSINESS_CONSULTING: 'MANAGE_BUSINESS_CONSULTING',
  MANAGE_MEMBERSHIP_ORGANIZATIONS: 'MANAGE_MEMBERSHIP_ORGANIZATIONS',
  MANAGE_RESEARCH_DEV: 'MANAGE_RESEARCH_DEV',
  MANAGE_SECURITY_PROTECTIVE: 'MANAGE_SECURITY_PROTECTIVE',
  MANUF_CHEMICAL: 'MANUF_CHEMICAL',
  MANUF_COMMERCIAL_PRINTING: 'MANUF_COMMERCIAL_PRINTING',
  MANUF_CONSUMER_PRODUCTS: 'MANUF_CONSUMER_PRODUCTS',
  MANUF_ELECTRONICS: 'MANUF_ELECTRONICS',
  MANUF_FOOD_BEV: 'MANUF_FOOD_BEV',
  MANUF_HEALTH_PRODUCTS: 'MANUF_HEALTH_PRODUCTS',
  MANUF_MACHINERY: 'MANUF_MACHINERY',
  MANUF_METAL_MINERAL: 'MANUF_METAL_MINERAL',
  MANUF_TEXTILE_APPAREL: 'MANUF_TEXTILE_APPAREL',
  MANUF_TRANSPORT_EQUIP: 'MANUF_TRANSPORT_EQUIP',
  MANUF_WOOD_PAPER: 'MANUF_WOOD_PAPER',
  MEDIA_COMM_ADVERTISING_PR: 'MEDIA_COMM_ADVERTISING_PR',
  MEDIA_COMM_BROADCAST: 'MEDIA_COMM_BROADCAST',
  MEDIA_COMM_FILM_PRODUCTION: 'MEDIA_COMM_FILM_PRODUCTION',
  MEDIA_COMM_MUSIC_SOUND: 'MEDIA_COMM_MUSIC_SOUND',
  MEDIA_COMM_PHOTOGRAPHY: 'MEDIA_COMM_PHOTOGRAPHY',
  MEDIA_COMM_PUBLISHING: 'MEDIA_COMM_PUBLISHING',
  MEDIA_COMM_TRANSLATION_LINGUISTIC: 'MEDIA_COMM_TRANSLATION_LINGUISTIC',
  MEDIA_COMM_VIDEO_GAME: 'MEDIA_COMM_VIDEO_GAME',
  NONPROFIT_NGO_CIVIC_SOCIAL: 'NONPROFIT_NGO_CIVIC_SOCIAL',
  NONPROFIT_NGO_FOUNDATIONS: 'NONPROFIT_NGO_FOUNDATIONS',
  NONPROFIT_NGO_RELIGIOUS: 'NONPROFIT_NGO_RELIGIOUS',
  PERSONAL_SERVICES_BEAUTY_WELLNESS: 'PERSONAL_SERVICES_BEAUTY_WELLNESS',
  PERSONAL_SERVICES_EVENT_SERVICES: 'PERSONAL_SERVICES_EVENT_SERVICES',
  PERSONAL_SERVICES_LAUNDRY_CLEANING: 'PERSONAL_SERVICES_LAUNDRY_CLEANING',
  PERSONAL_SERVICES_PET_CARE_VETERINARY: 'PERSONAL_SERVICES_PET_CARE_VETERINARY',
  PERSONAL_SERVICES_PRIVATE_HOUSEHOLDS: 'PERSONAL_SERVICES_PRIVATE_HOUSEHOLDS',
  PHARMA_BIOTECH_BIOTECH: 'PHARMA_BIOTECH_BIOTECH',
  PHARMA_BIOTECH_PHARMA: 'PHARMA_BIOTECH_PHARMA',
  PROF_SERVICES_ADVERTISING_AGENCIES: 'PROF_SERVICES_ADVERTISING_AGENCIES',
  PROF_SERVICES_DESIGN: 'PROF_SERVICES_DESIGN',
  PROF_SERVICES_PR_AGENCIES: 'PROF_SERVICES_PR_AGENCIES',
  REAL_ESTATE_PROPERTY_MANAGEMENT: 'REAL_ESTATE_PROPERTY_MANAGEMENT',
  REAL_ESTATE_AGENCIES: 'REAL_ESTATE_AGENCIES',
  RESTAURANTS_BARS_NIGHTCLUBS: 'RESTAURANTS_BARS_NIGHTCLUBS',
  RESTAURANTS_CATERING_CONTRACTORS: 'RESTAURANTS_CATERING_CONTRACTORS',
  RESTAURANTS_CAFES: 'RESTAURANTS_CAFES',
  RETAIL_AUCTIONS_GALLERIES: 'RETAIL_AUCTIONS_GALLERIES',
  RETAIL_AUTO_PARTS_ACCESSORIES: 'RETAIL_AUTO_PARTS_ACCESSORIES',
  RETAIL_BEAUTY_PERSONAL_ACCESSORIES: 'RETAIL_BEAUTY_PERSONAL_ACCESSORIES',
  RETAIL_ELECTRONICS_APPLIANCES: 'RETAIL_ELECTRONICS_APPLIANCES',
  RETAIL_CONVENIENCE_STORES: 'RETAIL_CONVENIENCE_STORES',
  RETAIL_DEPARTMENT_CLOTHING_SHOE: 'RETAIL_DEPARTMENT_CLOTHING_SHOE',
  RETAIL_DRUG_HEALTH_STORES: 'RETAIL_DRUG_HEALTH_STORES',
  RETAIL_ECOMMERCE: 'RETAIL_ECOMMERCE',
  RETAIL_FOOD_BEV_STORES: 'RETAIL_FOOD_BEV_STORES',
  RETAIL_GENERAL_MERCHANDISE: 'RETAIL_GENERAL_MERCHANDISE',
  RETAIL_GIFT_NOVELTY_SOUVENIR: 'RETAIL_GIFT_NOVELTY_SOUVENIR',
  RETAIL_GROCERY_STORES: 'RETAIL_GROCERY_STORES',
  RETAIL_HOME_FURNITURE_HOUSEWARES: 'RETAIL_HOME_FURNITURE_HOUSEWARES',
  RETAIL_HOME_IMPROVEMENT: 'RETAIL_HOME_IMPROVEMENT',
  RETAIL_LUXURY_GOODS: 'RETAIL_LUXURY_GOODS',
  RETAIL_MEDIA_ENTERTAINMENT: 'RETAIL_MEDIA_ENTERTAINMENT',
  RETAIL_OFFICE_SUPPLY_COPY: 'RETAIL_OFFICE_SUPPLY_COPY',
  RETAIL_PET_SUPPLIES: 'RETAIL_PET_SUPPLIES',
  RETAIL_SPECIALTY_STORES: 'RETAIL_SPECIALTY_STORES',
  RETAIL_SPORTING_GOODS: 'RETAIL_SPORTING_GOODS',
  RETAIL_TOYS_HOBBIES: 'RETAIL_TOYS_HOBBIES',
  RETAIL_WHOLESALE: 'RETAIL_WHOLESALE',
  SOCIAL_MEDIA_ONLINE_COMMUNITIES: 'SOCIAL_MEDIA_ONLINE_COMMUNITIES',
  SOCIAL_MEDIA_PROFESSIONAL_NETWORKING: 'SOCIAL_MEDIA_PROFESSIONAL_NETWORKING',
  SOCIAL_MEDIA_PLATFORMS: 'SOCIAL_MEDIA_PLATFORMS',
  TELECOM_TELECOMMUNICATIONS: 'TELECOM_TELECOMMUNICATIONS',
  TRANSPORT_AIRLINES_AIRPORTS: 'TRANSPORT_AIRLINES_AIRPORTS',
  TRANSPORT_CAR_TRUCK_RENTAL: 'TRANSPORT_CAR_TRUCK_RENTAL',
  TRANSPORT_MARINE: 'TRANSPORT_MARINE',
  TRANSPORT_PARKING_VALET: 'TRANSPORT_PARKING_VALET',
  TRANSPORT_RAIL: 'TRANSPORT_RAIL',
  TRANSPORT_SHIPPING_TRUCKING: 'TRANSPORT_SHIPPING_TRUCKING',
  TRANSPORT_TAXI_CAR_SERVICES: 'TRANSPORT_TAXI_CAR_SERVICES',
  TRANSPORT_MANAGEMENT: 'TRANSPORT_MANAGEMENT'
};

exports.EmployeeCountEnum = exports.$Enums.EmployeeCountEnum = {
  COUNT_1_TO_3: 'COUNT_1_TO_3',
  COUNT_3_TO_5: 'COUNT_3_TO_5',
  COUNT_6_TO_10: 'COUNT_6_TO_10',
  COUNT_11_TO_20: 'COUNT_11_TO_20',
  COUNT_20_TO_100: 'COUNT_20_TO_100',
  COUNT_100_TO_500: 'COUNT_100_TO_500',
  COUNT_500_PLUS: 'COUNT_500_PLUS'
};

exports.PositionsToFillEnum = exports.$Enums.PositionsToFillEnum = {
  COUNT_1_TO_2: 'COUNT_1_TO_2',
  COUNT_2_TO_5: 'COUNT_2_TO_5',
  COUNT_5_TO_20: 'COUNT_5_TO_20',
  COUNT_21_PLUS: 'COUNT_21_PLUS'
};

exports.CompanyUserStatusEnum = exports.$Enums.CompanyUserStatusEnum = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED'
};

exports.VeteranStatusEnum = exports.$Enums.VeteranStatusEnum = {
  DISABLED_VETERAN: 'DISABLED_VETERAN',
  RECENTLY_SEPARATED_VETERAN: 'RECENTLY_SEPARATED_VETERAN',
  ARMED_FORCES_SERVICE_MEDAL_VETERAN: 'ARMED_FORCES_SERVICE_MEDAL_VETERAN',
  OTHER_PROTECTED_VETERAN: 'OTHER_PROTECTED_VETERAN',
  NOT_A_PROTECTED_VETERAN: 'NOT_A_PROTECTED_VETERAN',
  DO_NOT_WISH_TO_ANSWER: 'DO_NOT_WISH_TO_ANSWER'
};

exports.GenderEnum = exports.$Enums.GenderEnum = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  NON_BINARY: 'NON_BINARY',
  DECLINE_TO_SELF_IDENTIFY: 'DECLINE_TO_SELF_IDENTIFY'
};

exports.EducationLevelEnum = exports.$Enums.EducationLevelEnum = {
  HIGH_SCHOOL_DEGREE: 'HIGH_SCHOOL_DEGREE',
  ASSOCIATES: 'ASSOCIATES',
  CERTIFICATE: 'CERTIFICATE',
  ADVANCED_CERTIFICATE: 'ADVANCED_CERTIFICATE',
  BACHELORS: 'BACHELORS',
  MASTERS: 'MASTERS',
  DOCTORATE: 'DOCTORATE',
  POSTDOCTORAL_STUDIES: 'POSTDOCTORAL_STUDIES',
  NON_DEGREE_SEEKING: 'NON_DEGREE_SEEKING',
  TECHNICAL_DIPLOMA: 'TECHNICAL_DIPLOMA'
};

exports.NylasEventStatusEnum = exports.$Enums.NylasEventStatusEnum = {
  confirmed: 'confirmed',
  tentative: 'tentative',
  cancelled: 'cancelled'
};

exports.EventTypeEnum = exports.$Enums.EventTypeEnum = {
  ALL__HANDS: 'ALL__HANDS',
  HUDDLE: 'HUDDLE',
  PANEL_REVIEW: 'PANEL_REVIEW',
  ONE__ON__ONE: 'ONE__ON__ONE',
  DEPARTMENT: 'DEPARTMENT',
  MEETING: 'MEETING',
  STRATEGY_MEETING: 'STRATEGY_MEETING',
  INTERNAL_CANDIDATE: 'INTERNAL_CANDIDATE',
  REVIEW: 'REVIEW'
};

exports.RepeatsEnum = exports.$Enums.RepeatsEnum = {
  DOES_NOT_REPEAT: 'DOES_NOT_REPEAT',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY',
  EVERY_WEEKDAY: 'EVERY_WEEKDAY'
};

exports.LocationTypeEnum = exports.$Enums.LocationTypeEnum = {
  ON_SITE: 'ON_SITE',
  REMOTE: 'REMOTE',
  HYBRID: 'HYBRID'
};

exports.PayTypeEnum = exports.$Enums.PayTypeEnum = {
  HOURLY: 'HOURLY',
  SALARY: 'SALARY'
};

exports.TeamSizeEnum = exports.$Enums.TeamSizeEnum = {
  COUNT_1_TO_5: 'COUNT_1_TO_5',
  COUNT_6_TO_10: 'COUNT_6_TO_10',
  COUNT_11_TO_20: 'COUNT_11_TO_20',
  COUNT_21_TO_50_PLUS: 'COUNT_21_TO_50_PLUS'
};

exports.WorkPlaceCandidateEnum = exports.$Enums.WorkPlaceCandidateEnum = {
  REMOTE: 'REMOTE',
  ON_SITE: 'ON_SITE',
  HYBRID: 'HYBRID'
};

exports.JobTypeEnum = exports.$Enums.JobTypeEnum = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  SEASONAL: 'SEASONAL',
  CONTRACTOR: 'CONTRACTOR',
  INTERNSHIP: 'INTERNSHIP',
  PER_DIEM: 'PER_DIEM',
  TEMPORARY: 'TEMPORARY',
  OTHER: 'OTHER'
};

exports.InviteStatusEnum = exports.$Enums.InviteStatusEnum = {
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
};

exports.WorkplaceTypeEnum = exports.$Enums.WorkplaceTypeEnum = {
  ENTIRELY_REMOTE: 'ENTIRELY_REMOTE',
  HYBRID_REMOTE: 'HYBRID_REMOTE',
  IN_PERSON: 'IN_PERSON'
};

exports.StageEnum = exports.$Enums.StageEnum = {
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  LOCATION: 'LOCATION',
  DESCRIPTION: 'DESCRIPTION',
  PREFERENCES: 'PREFERENCES',
  SKILLS: 'SKILLS',
  SCREENING_QUESTIONS: 'SCREENING_QUESTIONS',
  COMPLETE: 'COMPLETE'
};

exports.OpeningStatusEnum = exports.$Enums.OpeningStatusEnum = {
  OPEN: 'OPEN',
  FILLED: 'FILLED',
  ON_HOLD: 'ON_HOLD',
  CLOSED: 'CLOSED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  REJECTED: 'REJECTED'
};

exports.OpeningTypeEnum = exports.$Enums.OpeningTypeEnum = {
  NEW: 'NEW',
  REPLACEMENT: 'REPLACEMENT',
  INTERNAL_HIRE: 'INTERNAL_HIRE'
};

exports.ClosedReasonEnum = exports.$Enums.ClosedReasonEnum = {
  NO_LONGER_NEEDED: 'NO_LONGER_NEEDED',
  ON_HOLD: 'ON_HOLD',
  OPENED_BY_MISTAKE: 'OPENED_BY_MISTAKE'
};

exports.SearchStatusEnum = exports.$Enums.SearchStatusEnum = {
  ACTIVELY_SEARCHING: 'ACTIVELY_SEARCHING',
  NOT_ACTIVELY_SEARCHING: 'NOT_ACTIVELY_SEARCHING'
};

exports.WillingToRelocateEnum = exports.$Enums.WillingToRelocateEnum = {
  YES: 'YES',
  YES_TO_ONLY_SPECIFIC_AREAS: 'YES_TO_ONLY_SPECIFIC_AREAS',
  NO: 'NO'
};

exports.TryingToRelocateEnum = exports.$Enums.TryingToRelocateEnum = {
  YES: 'YES',
  ONLY_IF_NECESSARY: 'ONLY_IF_NECESSARY',
  NO: 'NO'
};

exports.JobTypePrefEnum = exports.$Enums.JobTypePrefEnum = {
  ENTIRELY_REMOTE: 'ENTIRELY_REMOTE',
  HYBRID_REMOTE: 'HYBRID_REMOTE',
  IN_PERSON: 'IN_PERSON'
};

exports.CanStartNewJobEnum = exports.$Enums.CanStartNewJobEnum = {
  IMMEDIATELY: 'IMMEDIATELY',
  ONE_WEEK: 'ONE_WEEK',
  TWO_WEEK: 'TWO_WEEK',
  NOT_SURE: 'NOT_SURE'
};

exports.CalendarProviderEnum = exports.$Enums.CalendarProviderEnum = {
  google: 'google',
  microsoft: 'microsoft'
};

exports.ConnectedEmailProviderEnum = exports.$Enums.ConnectedEmailProviderEnum = {
  google: 'google',
  microsoft: 'microsoft'
};

exports.EmailAddressConnectionTypeEnum = exports.$Enums.EmailAddressConnectionTypeEnum = {
  TO: 'TO',
  FROM: 'FROM',
  CC: 'CC',
  BCC: 'BCC'
};

exports.EmailRecordProviderEnum = exports.$Enums.EmailRecordProviderEnum = {
  NYLAS: 'NYLAS',
  POSTMARK: 'POSTMARK'
};

exports.PermissionEnum = exports.$Enums.PermissionEnum = {
  JOBS__EDIT: 'JOBS__EDIT',
  JOBS__DELETE: 'JOBS__DELETE',
  JOBS__VIEW: 'JOBS__VIEW',
  JOB_POSTINGS__VIEW: 'JOB_POSTINGS__VIEW',
  JOB_POSTINGS__CREATE: 'JOB_POSTINGS__CREATE',
  JOB_POSTINGS__EDIT: 'JOB_POSTINGS__EDIT',
  JOB_POSTINGS__DELETE: 'JOB_POSTINGS__DELETE',
  CANDIDATES__ADVANCE: 'CANDIDATES__ADVANCE',
  CANDIDATES__REJECT: 'CANDIDATES__REJECT',
  CANDIDATES__RESOLVE_DUPLICATES: 'CANDIDATES__RESOLVE_DUPLICATES',
  CANDIDATES__MESSAGE: 'CANDIDATES__MESSAGE',
  CANDIDATES__UPLOAD: 'CANDIDATES__UPLOAD',
  CANDIDATE_PROFILES__EDIT: 'CANDIDATE_PROFILES__EDIT',
  CANDIDATE_PROFILES__DELETE: 'CANDIDATE_PROFILES__DELETE',
  CANDIDATE_PROFILES__VIEW: 'CANDIDATE_PROFILES__VIEW',
  PRIVATE_NOTES__VIEW: 'PRIVATE_NOTES__VIEW',
  INTERVIEWS__SCHEDULE: 'INTERVIEWS__SCHEDULE',
  INTERVIEWS__EDIT: 'INTERVIEWS__EDIT',
  INTERVIEWS__DELETE: 'INTERVIEWS__DELETE',
  INTERVIEWS__VIEW: 'INTERVIEWS__VIEW',
  FEEDBACK__SUBMIT: 'FEEDBACK__SUBMIT',
  FEEDBACK__VIEW: 'FEEDBACK__VIEW',
  REFERRALS__SUBMIT: 'REFERRALS__SUBMIT',
  REPORTS__GENERATE: 'REPORTS__GENERATE',
  REPORTS__VIEW: 'REPORTS__VIEW',
  USERS__INVITE: 'USERS__INVITE',
  USERS_PERMISSIONS__EDIT: 'USERS_PERMISSIONS__EDIT',
  DEMOGRAPHIC_INFORMATION__VIEW: 'DEMOGRAPHIC_INFORMATION__VIEW',
  COMPANY_SETTINGS__EDIT: 'COMPANY_SETTINGS__EDIT',
  MESSAGE_TEMPLATES__EDIT: 'MESSAGE_TEMPLATES__EDIT',
  TEMPLATE_JOB_DESCRIPTION_UPSERT: 'TEMPLATE_JOB_DESCRIPTION_UPSERT',
  TEMPLATE_JOB_DESCRIPTION_DELETE: 'TEMPLATE_JOB_DESCRIPTION_DELETE',
  REQUISITION_JOB_DESCRIPTION_UPSERT: 'REQUISITION_JOB_DESCRIPTION_UPSERT',
  REQUISITION_JOB_DESCRIPTION_DELETE: 'REQUISITION_JOB_DESCRIPTION_DELETE',
  REQUISITION_UPSERT: 'REQUISITION_UPSERT',
  REQUISITION_DELETE: 'REQUISITION_DELETE',
  REQUISITION_SKILL_UPSERT: 'REQUISITION_SKILL_UPSERT',
  REQUISITION_SKILL_DELETE: 'REQUISITION_SKILL_DELETE',
  JOB_LISTING_UPSERT: 'JOB_LISTING_UPSERT',
  JOB_LISTING_DELETE: 'JOB_LISTING_DELETE',
  SCREENING_QUESTION_UPSERT: 'SCREENING_QUESTION_UPSERT',
  SCREENING_QUESTION_DELETE: 'SCREENING_QUESTION_DELETE',
  JOB_LISTING_SCREENING_QUESTION_UPSERT: 'JOB_LISTING_SCREENING_QUESTION_UPSERT',
  JOB_LISTING_SCREENING_QUESTION_DELETE: 'JOB_LISTING_SCREENING_QUESTION_DELETE',
  SCREENING_QUESTION_ANSWER_UPSERT: 'SCREENING_QUESTION_ANSWER_UPSERT',
  SCREENING_QUESTION_ANSWER_DELETE: 'SCREENING_QUESTION_ANSWER_DELETE',
  HIRING_TEAM_MEMBER_UPSERT: 'HIRING_TEAM_MEMBER_UPSERT',
  HIRING_TEAM_MEMBER_DELETE: 'HIRING_TEAM_MEMBER_DELETE',
  CANDIDATE_COLLABORATOR_UPSERT: 'CANDIDATE_COLLABORATOR_UPSERT',
  CANDIDATE_COLLABORATOR_DELETE: 'CANDIDATE_COLLABORATOR_DELETE',
  STAGE_COLLABORATOR_UPSERT: 'STAGE_COLLABORATOR_UPSERT',
  STAGE_COLLABORATOR_DELETE: 'STAGE_COLLABORATOR_DELETE',
  TEMPLATE_STAGE_UPSERT: 'TEMPLATE_STAGE_UPSERT',
  TEMPLATE_STAGE_DELETE: 'TEMPLATE_STAGE_DELETE',
  TEMPLATE_PIPELINE_UPSERT: 'TEMPLATE_PIPELINE_UPSERT',
  TEMPLATE_PIPELINE_DELETE: 'TEMPLATE_PIPELINE_DELETE',
  TEMPLATE_MILESTONE_UPSERT: 'TEMPLATE_MILESTONE_UPSERT',
  TEMPLATE_MILESTONE_DELETE: 'TEMPLATE_MILESTONE_DELETE',
  JOB_OPENING_UPSERT: 'JOB_OPENING_UPSERT',
  JOB_OPENING_DELETE: 'JOB_OPENING_DELETE',
  TEMPLATE_MESSAGE_UPSERT: 'TEMPLATE_MESSAGE_UPSERT',
  TEMPLATE_MESSAGE_DELETE: 'TEMPLATE_MESSAGE_DELETE',
  CANDIDATE_MESSAGE_UPSERT: 'CANDIDATE_MESSAGE_UPSERT',
  CANDIDATE_MESSAGE_DELETE: 'CANDIDATE_MESSAGE_DELETE',
  STAGE_SETTINGS_UPSERT: 'STAGE_SETTINGS_UPSERT',
  STAGE_SETTINGS_DELETE: 'STAGE_SETTINGS_DELETE',
  JOB_PIPELINE_UPSERT: 'JOB_PIPELINE_UPSERT',
  JOB_PIPELINE_DELETE: 'JOB_PIPELINE_DELETE',
  APPROVAL_WORKFLOW__VIEW: 'APPROVAL_WORKFLOW__VIEW',
  APPROVAL_WORKFLOW__CREATE: 'APPROVAL_WORKFLOW__CREATE',
  APPROVAL_WORKFLOW__EDIT: 'APPROVAL_WORKFLOW__EDIT',
  APPROVAL_WORKFLOW__DELETE: 'APPROVAL_WORKFLOW__DELETE',
  SECTION_TEMPLATE_UPSERT: 'SECTION_TEMPLATE_UPSERT',
  SECTION_TEMPLATE_DELETE: 'SECTION_TEMPLATE_DELETE',
  CUSTOM_FIELD_UPSERT: 'CUSTOM_FIELD_UPSERT',
  CUSTOM_FIELD_DELETE: 'CUSTOM_FIELD_DELETE',
  CANDIDATE_OFFER_UPSERT: 'CANDIDATE_OFFER_UPSERT',
  CANDIDATE_OFFER_DELETE: 'CANDIDATE_OFFER_DELETE',
  CANDIDATE_OFFER_CUSTOM_FIELD_UPSERT: 'CANDIDATE_OFFER_CUSTOM_FIELD_UPSERT',
  CANDIDATE_OFFER_CUSTOM_FIELD_DELETE: 'CANDIDATE_OFFER_CUSTOM_FIELD_DELETE',
  CANDIDATE_OFFER_FILE_UPSERT: 'CANDIDATE_OFFER_FILE_UPSERT',
  CANDIDATE_OFFER_FILE_DELETE: 'CANDIDATE_OFFER_FILE_DELETE',
  CANDIDATE_OFFER_VERSION_UPSERT: 'CANDIDATE_OFFER_VERSION_UPSERT',
  CANDIDATE_OFFER_VERSION_DELETE: 'CANDIDATE_OFFER_VERSION_DELETE',
  DEFAULT_TOKEN_UPSERT: 'DEFAULT_TOKEN_UPSERT',
  DEFAULT_TOKEN_DELETE: 'DEFAULT_TOKEN_DELETE',
  OFFER_CUSTOM_FIELD_UPSERT: 'OFFER_CUSTOM_FIELD_UPSERT',
  OFFER_CUSTOM_FIELD_DELETE: 'OFFER_CUSTOM_FIELD_DELETE',
  OFFER_DOCUMENT_TEMPLATE_UPSERT: 'OFFER_DOCUMENT_TEMPLATE_UPSERT',
  OFFER_DOCUMENT_TEMPLATE_DELETE: 'OFFER_DOCUMENT_TEMPLATE_DELETE',
  OFFER_DOCUMENT_TEMPLATE_VALIDATE: 'OFFER_DOCUMENT_TEMPLATE_VALIDATE',
  OFFER_DOCUMENT_TEMPLATE_SECTION_UPSERT: 'OFFER_DOCUMENT_TEMPLATE_SECTION_UPSERT',
  OFFER_DOCUMENT_TEMPLATE_SECTION_DELETE: 'OFFER_DOCUMENT_TEMPLATE_SECTION_DELETE',
  OFFER_SECTION_TEMPLATE_UPSERT: 'OFFER_SECTION_TEMPLATE_UPSERT',
  OFFER_SECTION_TEMPLATE_DELETE: 'OFFER_SECTION_TEMPLATE_DELETE',
  OFFER_TEMPLATE_CONDITION_UPSERT: 'OFFER_TEMPLATE_CONDITION_UPSERT',
  OFFER_TEMPLATE_CONDITION_DELETE: 'OFFER_TEMPLATE_CONDITION_DELETE',
  TOKEN_TEST_RESULT_UPSERT: 'TOKEN_TEST_RESULT_UPSERT',
  TOKEN_TEST_RESULT_DELETE: 'TOKEN_TEST_RESULT_DELETE',
  SCORECARD__VIEW: 'SCORECARD__VIEW',
  SCORECARD__SUBMIT: 'SCORECARD__SUBMIT'
};

exports.ApprovalStatusEnum = exports.$Enums.ApprovalStatusEnum = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

exports.JobLevelEnum = exports.$Enums.JobLevelEnum = {
  ENTRY_LEVEL: 'ENTRY_LEVEL',
  INTERMEDIATE_OR_EXPERIENCED: 'INTERMEDIATE_OR_EXPERIENCED',
  FIRST_MANAGEMENT: 'FIRST_MANAGEMENT',
  MIDDLE_MANAGEMENT: 'MIDDLE_MANAGEMENT',
  SENIOR_OR_EXECUTIVE: 'SENIOR_OR_EXECUTIVE'
};

exports.YearsOfExperienceEnum = exports.$Enums.YearsOfExperienceEnum = {
  COUNT_1_TO_2: 'COUNT_1_TO_2',
  COUNT_3_TO_5: 'COUNT_3_TO_5',
  COUNT_5_TO_7: 'COUNT_5_TO_7',
  COUNT_7_TO_9: 'COUNT_7_TO_9',
  COUNT_10_PLUS: 'COUNT_10_PLUS'
};

exports.EducationLevelPrefEnum = exports.$Enums.EducationLevelPrefEnum = {
  NONE: 'NONE',
  HIGH_SCHOOL: 'HIGH_SCHOOL',
  ASSOCIATES: 'ASSOCIATES',
  CERTIFICATE: 'CERTIFICATE',
  ADVANCED_CERTIFICATE: 'ADVANCED_CERTIFICATE',
  BACHELORS: 'BACHELORS',
  MASTERS: 'MASTERS',
  DOCTORATE: 'DOCTORATE',
  POSTDOCTORAL_STUDIES: 'POSTDOCTORAL_STUDIES',
  NON_DEGREE_SEEKING: 'NON_DEGREE_SEEKING',
  TECHNICAL_DIPLOMA: 'TECHNICAL_DIPLOMA',
  UNDERGRADUATE_DEGREE: 'UNDERGRADUATE_DEGREE',
  GRADUATE_DEGREE: 'GRADUATE_DEGREE'
};

exports.TravelTypeEnum = exports.$Enums.TravelTypeEnum = {
  YES: 'YES',
  NO: 'NO'
};

exports.JobStatusEnum = exports.$Enums.JobStatusEnum = {
  OPEN: 'OPEN',
  ON_HOLD: 'ON_HOLD',
  CLOSED: 'CLOSED',
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  REJECTED: 'REJECTED'
};

exports.RoleEnum = exports.$Enums.RoleEnum = {
  SCALIS_ADMIN: 'SCALIS_ADMIN',
  RECRUITER: 'RECRUITER',
  HIRING_MANAGER: 'HIRING_MANAGER',
  HIRING_TEAM_MEMBER: 'HIRING_TEAM_MEMBER',
  JOB_VIEWER: 'JOB_VIEWER',
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  GUEST: 'GUEST',
  MEMBER: 'MEMBER',
  STAGE_COLLABORATOR: 'STAGE_COLLABORATOR'
};

exports.CurrentStageEnum = exports.$Enums.CurrentStageEnum = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  UPLOAD_RESUME: 'UPLOAD_RESUME',
  PROFILE: 'PROFILE',
  REVIEW_PROFILE: 'REVIEW_PROFILE',
  SCREENING_QUESTIONS: 'SCREENING_QUESTIONS'
};

exports.ScorecardQuestionTypeEnum = exports.$Enums.ScorecardQuestionTypeEnum = {
  FREE_RESPONSE: 'FREE_RESPONSE',
  YES_NO: 'YES_NO',
  NUMERICAL: 'NUMERICAL',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DATE: 'DATE',
  CHECKBOXES: 'CHECKBOXES'
};

exports.SectionTypeEnum = exports.$Enums.SectionTypeEnum = {
  SKILLS: 'SKILLS',
  QUESTIONS: 'QUESTIONS'
};

exports.QuestionTypeEnum = exports.$Enums.QuestionTypeEnum = {
  FREE_RESPONSE: 'FREE_RESPONSE',
  YES_NO: 'YES_NO',
  NUMERICAL: 'NUMERICAL',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  FILE: 'FILE',
  URL: 'URL',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT'
};

exports.PreferredAnswerTypeEnum = exports.$Enums.PreferredAnswerTypeEnum = {
  AT_LEAST_ONE: 'AT_LEAST_ONE',
  ALL_OF: 'ALL_OF',
  NONE: 'NONE'
};

exports.SelectionDisplayEnum = exports.$Enums.SelectionDisplayEnum = {
  DROPDOWN: 'DROPDOWN',
  PICKLIST: 'PICKLIST'
};

exports.SkillTypeEnum = exports.$Enums.SkillTypeEnum = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM'
};

exports.InterviewLengthEnum = exports.$Enums.InterviewLengthEnum = {
  DUMMY: 'DUMMY'
};

exports.MessageTypeEnum = exports.$Enums.MessageTypeEnum = {
  SEND_SCHEDULER_LINK_INVITE: 'SEND_SCHEDULER_LINK_INVITE',
  INVITE_TO_APPLY: 'INVITE_TO_APPLY',
  CANDIDATE_OFFER_LETTER: 'CANDIDATE_OFFER_LETTER',
  CANDIDATE_OFFER: 'CANDIDATE_OFFER',
  REJECT_CANDIDATE: 'REJECT_CANDIDATE',
  AUTO_REJECT_CANDIDATE: 'AUTO_REJECT_CANDIDATE',
  ADVANCE_CANDIDATE: 'ADVANCE_CANDIDATE',
  ADD_SEQUENCE_STEP: 'ADD_SEQUENCE_STEP',
  INVITE_TO_FILL_PROFILE: 'INVITE_TO_FILL_PROFILE',
  CANDIDATE_AVAILABILITY_REQUEST: 'CANDIDATE_AVAILABILITY_REQUEST',
  CANDIDATE_EMAIL_GENERIC: 'CANDIDATE_EMAIL_GENERIC',
  CANDIDATE_INTERVIEW_CONFIRMATION: 'CANDIDATE_INTERVIEW_CONFIRMATION',
  CANDIDATE_REFERRAL_RECEIPT: 'CANDIDATE_REFERRAL_RECEIPT',
  CANDIDATE_SELF_SCHEDULE_REQUEST: 'CANDIDATE_SELF_SCHEDULE_REQUEST',
  INTERVIEWER_INVITE: 'INTERVIEWER_INVITE',
  SCORECARD_DUE: 'SCORECARD_DUE',
  TEAM_EMAIL: 'TEAM_EMAIL',
  THANK_YOU_FOR_APPLYING: 'THANK_YOU_FOR_APPLYING',
  GENERIC: 'GENERIC'
};

exports.MessageOwnerEnum = exports.$Enums.MessageOwnerEnum = {
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY'
};

exports.NameEnum = exports.$Enums.NameEnum = {
  SOURCING: 'SOURCING',
  APPLICATION_REVIEW: 'APPLICATION_REVIEW',
  PRE_SCREEN: 'PRE_SCREEN',
  INTERVIEWING: 'INTERVIEWING',
  OFFER: 'OFFER',
  HIRED: 'HIRED'
};

exports.TemplateStageVisibilityEnum = exports.$Enums.TemplateStageVisibilityEnum = {
  VISIBLE_TO_CANDIDATE: 'VISIBLE_TO_CANDIDATE',
  VISIBLE_ONLY_INTERNALLY: 'VISIBLE_ONLY_INTERNALLY'
};

exports.EnrichmentSourceEnum = exports.$Enums.EnrichmentSourceEnum = {
  PEOPLE_DATA_LABS: 'PEOPLE_DATA_LABS',
  CRUSTDATA: 'CRUSTDATA'
};

exports.EnrichedPhoneNumberTypeEnum = exports.$Enums.EnrichedPhoneNumberTypeEnum = {
  MOBILE: 'MOBILE',
  OTHER: 'OTHER'
};

exports.EnrichedEmailTypeEnum = exports.$Enums.EnrichedEmailTypeEnum = {
  BUSINESS: 'BUSINESS',
  PERSONAL: 'PERSONAL'
};

exports.UploadedCandidateTypeEnum = exports.$Enums.UploadedCandidateTypeEnum = {
  UPLOADED: 'UPLOADED',
  SCRAPED: 'SCRAPED',
  LINKEDIN_SCRAPED: 'LINKEDIN_SCRAPED',
  GMAIL_SCRAPED: 'GMAIL_SCRAPED',
  INDEED_SCRAPED: 'INDEED_SCRAPED',
  SCRAPED_MERGED: 'SCRAPED_MERGED'
};

exports.RoleTypeEnum = exports.$Enums.RoleTypeEnum = {
  FREELANCE: 'FREELANCE',
  VOLUNTEER_WORK: 'VOLUNTEER_WORK',
  GIG_ECONOMY_JOBS: 'GIG_ECONOMY_JOBS',
  RESEARCH_AND_ACADEMIC_PROJECTS: 'RESEARCH_AND_ACADEMIC_PROJECTS',
  CARETAKING_AND_FAMILY_RESPONSIBILITIES: 'CARETAKING_AND_FAMILY_RESPONSIBILITIES',
  TRAVEL_AND_EXCHANGE_PROGRAMS: 'TRAVEL_AND_EXCHANGE_PROGRAMS'
};

exports.WebsiteTypeEnum = exports.$Enums.WebsiteTypeEnum = {
  GITHUB: 'GITHUB',
  TIKTOK: 'TIKTOK',
  INSTAGRAM: 'INSTAGRAM',
  LINKEDIN: 'LINKEDIN',
  TWITTER: 'TWITTER',
  FACEBOOK: 'FACEBOOK',
  PERSONAL_1: 'PERSONAL_1',
  PERSONAL_2: 'PERSONAL_2'
};

exports.DocumentTypeEnum = exports.$Enums.DocumentTypeEnum = {
  OFFER_LETTER: 'OFFER_LETTER',
  RESUME: 'RESUME',
  OTHER: 'OTHER'
};

exports.InvitationStatusEnum = exports.$Enums.InvitationStatusEnum = {
  INVITED: 'INVITED',
  INVITE_ACCEPTED: 'INVITE_ACCEPTED',
  EXPIRED: 'EXPIRED',
  DELETED: 'DELETED'
};

exports.ExternalApplicationStatusEnum = exports.$Enums.ExternalApplicationStatusEnum = {
  APPLICATION_REVIEW: 'APPLICATION_REVIEW',
  PRE_SCREEN: 'PRE_SCREEN',
  INTERVIEWS: 'INTERVIEWS',
  OFFER: 'OFFER',
  HIRED: 'HIRED'
};

exports.PaymentStatusEnum = exports.$Enums.PaymentStatusEnum = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};

exports.SubscriptionStatusEnum = exports.$Enums.SubscriptionStatusEnum = {
  ACTIVE: 'ACTIVE',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
  PAUSED: 'PAUSED'
};

exports.OfferStatusEnum = exports.$Enums.OfferStatusEnum = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  DELETED: 'DELETED',
  NOT_CREATED: 'NOT_CREATED',
  NOT_SENT: 'NOT_SENT',
  PENDING_SEND: 'PENDING_SEND',
  SENT: 'SENT',
  SENT_AWAITING_SIGNATURE: 'SENT_AWAITING_SIGNATURE',
  SIGNED: 'SIGNED',
  VOIDED: 'VOIDED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  DRAFT: 'DRAFT'
};

exports.OfferFileTypeEnum = exports.$Enums.OfferFileTypeEnum = {
  PDF: 'PDF',
  DOCX: 'DOCX',
  ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT',
  SIGNED_DOCUMENT: 'SIGNED_DOCUMENT'
};

exports.TokenNameEnum = exports.$Enums.TokenNameEnum = {
  APPLICATION_DATE: 'APPLICATION_DATE',
  CANDIDATE_APPLICATION_ID: 'CANDIDATE_APPLICATION_ID',
  CANDIDATE_COMPANY: 'CANDIDATE_COMPANY',
  CANDIDATE_CURRENT_TITLE: 'CANDIDATE_CURRENT_TITLE',
  MEDALIST_DESIGNATION: 'MEDALIST_DESIGNATION',
  SOURCE_NAME: 'SOURCE_NAME',
  STAGE_NAME_CURRENT: 'STAGE_NAME_CURRENT',
  STAGE_NAME_NEXT: 'STAGE_NAME_NEXT',
  CANDIDATE_LINKEDIN_PROFILE: 'CANDIDATE_LINKEDIN_PROFILE',
  CANDIDATE_SCHOOL: 'CANDIDATE_SCHOOL',
  CANDIDATE_EMAIL_ADDRESS: 'CANDIDATE_EMAIL_ADDRESS',
  CANDIDATE_FIRST_NAME: 'CANDIDATE_FIRST_NAME',
  CANDIDATE_FULL_NAME: 'CANDIDATE_FULL_NAME',
  CANDIDATE_LAST_NAME: 'CANDIDATE_LAST_NAME',
  CANDIDATE_MAILING_ADDRESS: 'CANDIDATE_MAILING_ADDRESS',
  CANDIDATE_PHONE: 'CANDIDATE_PHONE',
  CANDIDATE_PROFILE_ID: 'CANDIDATE_PROFILE_ID',
  CANDIDATE_PROFILE_LINK: 'CANDIDATE_PROFILE_LINK',
  COMPANY_LINKEDIN_URL: 'COMPANY_LINKEDIN_URL',
  COMPANY_NAME: 'COMPANY_NAME',
  COMPANY_WEBSITE_URL: 'COMPANY_WEBSITE_URL',
  OFFICE: 'OFFICE',
  OFFICE_ADDRESS: 'OFFICE_ADDRESS',
  INTERVIEW_DATE: 'INTERVIEW_DATE',
  INTERVIEW_END_TIME: 'INTERVIEW_END_TIME',
  INTERVIEWER_JOB_TITLE: 'INTERVIEWER_JOB_TITLE',
  INTERVIEWER_NAME: 'INTERVIEWER_NAME',
  INTERVIEW_INVITE_LOCATION: 'INTERVIEW_INVITE_LOCATION',
  INTERVIEW_KIT_LINK: 'INTERVIEW_KIT_LINK',
  INTERVIEW_NAME: 'INTERVIEW_NAME',
  INTERVIEW_ORGANIZER_NAME: 'INTERVIEW_ORGANIZER_NAME',
  INTERVIEW_PANEL: 'INTERVIEW_PANEL',
  INTERVIEW_START_TIME: 'INTERVIEW_START_TIME',
  INTERVIEW_SUMMARY: 'INTERVIEW_SUMMARY',
  INVITATION_LINK: 'INVITATION_LINK',
  SCORECARD_LINK: 'SCORECARD_LINK',
  SELF_SCHEDULER_LINK: 'SELF_SCHEDULER_LINK',
  AVAILABILITY_SUBMISSION_LINK: 'AVAILABILITY_SUBMISSION_LINK',
  HIRING_MANAGER_NAME: 'HIRING_MANAGER_NAME',
  INTERNAL_JOB_NAME: 'INTERNAL_JOB_NAME',
  JOB_POST_URL: 'JOB_POST_URL',
  JOB_REQ_NAME: 'JOB_REQ_NAME',
  LINK_TO_APPLY: 'LINK_TO_APPLY',
  LISTING_DESCRIPTION: 'LISTING_DESCRIPTION',
  JOB_DESCRIPTION: 'JOB_DESCRIPTION',
  PRIMARY_CONTACT: 'PRIMARY_CONTACT',
  PUBLIC_LISTING_TITLE: 'PUBLIC_LISTING_TITLE',
  RECRUITER_NAME: 'RECRUITER_NAME',
  REQUISITION_ID: 'REQUISITION_ID',
  MY_EMAIL_ADDRESS: 'MY_EMAIL_ADDRESS',
  MY_FIRST_NAME: 'MY_FIRST_NAME',
  MY_FULL_NAME: 'MY_FULL_NAME',
  MY_JOB_TITLE: 'MY_JOB_TITLE',
  MY_SCALIS_PROFILE_URL: 'MY_SCALIS_PROFILE_URL',
  SIGN_OFF: 'SIGN_OFF',
  ANNUAL_BONUS: 'ANNUAL_BONUS',
  ANNUAL_SALARY: 'ANNUAL_SALARY',
  BENEFITS: 'BENEFITS',
  EQUITY_PACKAGE: 'EQUITY_PACKAGE',
  HOURLY_RATE: 'HOURLY_RATE',
  JOB_TYPE: 'JOB_TYPE',
  OFFER_EXPIRATION_DATE: 'OFFER_EXPIRATION_DATE',
  REPORTING_MANAGER: 'REPORTING_MANAGER',
  SALES_COMMISSION: 'SALES_COMMISSION',
  SIGN_ON_BONUS: 'SIGN_ON_BONUS',
  SPOT_BONUS: 'SPOT_BONUS',
  START_DATE: 'START_DATE',
  STOCK_OPTIONS: 'STOCK_OPTIONS',
  VARIABLE_COMPENSATION: 'VARIABLE_COMPENSATION',
  CANDIDATE_SIGNATURE_DATE: 'CANDIDATE_SIGNATURE_DATE',
  CANDIDATE_SIGNATURE: 'CANDIDATE_SIGNATURE',
  COMPANY_USER_SIGNATURE_DATE: 'COMPANY_USER_SIGNATURE_DATE',
  COMPANY_USER_SIGNATURE: 'COMPANY_USER_SIGNATURE',
  DAY_OF_WEEK: 'DAY_OF_WEEK',
  TODAY_DATE: 'TODAY_DATE',
  CANDIDATE_NAME: 'CANDIDATE_NAME',
  JOB_TITLE: 'JOB_TITLE',
  MANAGER: 'MANAGER',
  PAY_TYPE: 'PAY_TYPE',
  OFFICE_NAME: 'OFFICE_NAME'
};

exports.TokenCategoryNameEnum = exports.$Enums.TokenCategoryNameEnum = {
  APPLICATION_INFO: 'APPLICATION_INFO',
  CANDIDATE_PROFILE: 'CANDIDATE_PROFILE',
  COMPANY_INFO: 'COMPANY_INFO',
  INTERVIEW_TOKENS: 'INTERVIEW_TOKENS',
  JOB_DETAILS: 'JOB_DETAILS',
  MY_INFORMATION: 'MY_INFORMATION',
  OFFER_DETAILS: 'OFFER_DETAILS',
  SIGNATURE_TOKENS: 'SIGNATURE_TOKENS',
  SYSTEM_TOKENS: 'SYSTEM_TOKENS',
  SECTION_TOKENS: 'SECTION_TOKENS',
  CUSTOM_FIELD: 'CUSTOM_FIELD'
};

exports.DefaultTokenTypeEnum = exports.$Enums.DefaultTokenTypeEnum = {
  EMAIL: 'EMAIL',
  OFFER: 'OFFER'
};

exports.OfferDocumentTemplateTypeEnum = exports.$Enums.OfferDocumentTemplateTypeEnum = {
  OFFER_LETTER: 'OFFER_LETTER',
  NDA: 'NDA',
  OTHER: 'OTHER'
};

exports.OfferDocumentTemplateStatusEnum = exports.$Enums.OfferDocumentTemplateStatusEnum = {
  VERIFIED: 'VERIFIED',
  NOT_TESTED: 'NOT_TESTED',
  FAILED: 'FAILED'
};

exports.ConditionTypeEnum = exports.$Enums.ConditionTypeEnum = {
  DEPARTMENT: 'DEPARTMENT',
  OFFICE: 'OFFICE',
  PAY_TYPE: 'PAY_TYPE',
  EMPLOYMENT_TYPE: 'EMPLOYMENT_TYPE'
};

exports.TokenStatusEnum = exports.$Enums.TokenStatusEnum = {
  VERIFIED: 'VERIFIED',
  NOT_TESTED: 'NOT_TESTED',
  FAILED_TEST: 'FAILED_TEST',
  NOT_AVAILABLE_DUE_TO_CONDITIONS: 'NOT_AVAILABLE_DUE_TO_CONDITIONS'
};

exports.CustomFieldInputTypeEnum = exports.$Enums.CustomFieldInputTypeEnum = {
  TEXT: 'TEXT',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  CURRENCY: 'CURRENCY'
};

exports.CoreReportNameEnum = exports.$Enums.CoreReportNameEnum = {
  JOB_STATUS_REPORT: 'JOB_STATUS_REPORT',
  JOB_OPENINGS_REPORT: 'JOB_OPENINGS_REPORT',
  SOURCE_QUALITY_REPORT: 'SOURCE_QUALITY_REPORT',
  OFFER_DETAILS_REPORT: 'OFFER_DETAILS_REPORT',
  CANDIDATE_SUMMARY: 'CANDIDATE_SUMMARY',
  MILESTONE_METRICS: 'MILESTONE_METRICS',
  PIPELINE_METRICS: 'PIPELINE_METRICS',
  EEOC_REPORT: 'EEOC_REPORT'
};

exports.ReportSchedulerType = exports.$Enums.ReportSchedulerType = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING'
};

exports.RepeatType = exports.$Enums.RepeatType = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  EVERY_WEEKDAY: 'EVERY_WEEKDAY',
  CUSTOM: 'CUSTOM'
};

exports.EmailProviderEnum = exports.$Enums.EmailProviderEnum = {
  POSTMARK: 'POSTMARK',
  MAILPIT: 'MAILPIT',
  SES: 'SES'
};

exports.CompanySavedViewTypeEnum = exports.$Enums.CompanySavedViewTypeEnum = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM'
};

exports.CompanySavedViewLayoutEnum = exports.$Enums.CompanySavedViewLayoutEnum = {
  LIST: 'LIST',
  KANBAN: 'KANBAN'
};

exports.CompanySavedViewLocationEnum = exports.$Enums.CompanySavedViewLocationEnum = {
  TALENT_POOL: 'TALENT_POOL',
  REQUISITION: 'REQUISITION',
  ALL_LOCATIONS: 'ALL_LOCATIONS'
};

exports.CompanySavedViewVisibilityEnum = exports.$Enums.CompanySavedViewVisibilityEnum = {
  PRIVATE: 'PRIVATE',
  TEAM: 'TEAM',
  EVERYONE: 'EVERYONE'
};

exports.TalentPoolVisibilityEnum = exports.$Enums.TalentPoolVisibilityEnum = {
  PRIVATE: 'PRIVATE',
  TEAM: 'TEAM',
  EVERYONE: 'EVERYONE'
};

exports.TalentPoolTypeEnum = exports.$Enums.TalentPoolTypeEnum = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM'
};

exports.DatePostedEnum = exports.$Enums.DatePostedEnum = {
  PAST_TWENTY_FOUR_HOURS: 'PAST_TWENTY_FOUR_HOURS',
  PAST_THREE_DAYS: 'PAST_THREE_DAYS',
  PAST_WEEK: 'PAST_WEEK',
  PAST_MONTH: 'PAST_MONTH'
};

exports.RelocationTypePreferenceEnum = exports.$Enums.RelocationTypePreferenceEnum = {
  YES: 'YES',
  NO: 'NO',
  SPECIFIC_AREAS: 'SPECIFIC_AREAS'
};

exports.ApprovalWorkflowScopeEnum = exports.$Enums.ApprovalWorkflowScopeEnum = {
  JOB: 'JOB',
  OFFER: 'OFFER',
  OPENING: 'OPENING'
};

exports.IconTypeEnum = exports.$Enums.IconTypeEnum = {
  UNICODE: 'UNICODE',
  FONTAWESOME: 'FONTAWESOME'
};

exports.CustomCandidateFieldTypeEnum = exports.$Enums.CustomCandidateFieldTypeEnum = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  SELECT: 'SELECT',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
  DATE: 'DATE',
  FILES: 'FILES',
  PERSON: 'PERSON',
  CHECKBOX: 'CHECKBOX',
  URL: 'URL',
  CURRENCY: 'CURRENCY',
  RADIO: 'RADIO',
  RANGE: 'RANGE',
  DATE_RANGE: 'DATE_RANGE'
};

exports.CustomFieldVisibilityEnum = exports.$Enums.CustomFieldVisibilityEnum = {
  PUBLIC: 'PUBLIC',
  INTERNAL: 'INTERNAL'
};

exports.CustomFieldProviderEnum = exports.$Enums.CustomFieldProviderEnum = {
  HIRING_TEAM: 'HIRING_TEAM',
  RECRUITERS_ONLY: 'RECRUITERS_ONLY'
};

exports.SequenceStatusEnum = exports.$Enums.SequenceStatusEnum = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
  NOT_STARTED: 'NOT_STARTED'
};

exports.SequenceVisibilityEnum = exports.$Enums.SequenceVisibilityEnum = {
  PRIVATE: 'PRIVATE',
  EVERYONE: 'EVERYONE'
};

exports.SequenceStepSchedulerTypeEnum = exports.$Enums.SequenceStepSchedulerTypeEnum = {
  IMMEDIATELY: 'IMMEDIATELY',
  AFTER_X_DAYS: 'AFTER_X_DAYS',
  AFTER_X_HOURS: 'AFTER_X_HOURS',
  AFTER_X_MINUTES: 'AFTER_X_MINUTES'
};

exports.SequenceStepSendTimeTypeEnum = exports.$Enums.SequenceStepSendTimeTypeEnum = {
  THROUGHOUT_DAY: 'THROUGHOUT_DAY',
  CUSTOM_TIME: 'CUSTOM_TIME'
};

exports.SequenceStepSpreadStrategyEnum = exports.$Enums.SequenceStepSpreadStrategyEnum = {
  EVENLY: 'EVENLY',
  WARM: 'WARM'
};

exports.SequenceCandidateStatusEnum = exports.$Enums.SequenceCandidateStatusEnum = {
  ACTIVE: 'ACTIVE',
  FINISHED_REPLIED: 'FINISHED_REPLIED',
  FINISHED_DID_NOT_REPLY: 'FINISHED_DID_NOT_REPLY',
  FINISHED_BOUNCED: 'FINISHED_BOUNCED',
  FINISHED: 'FINISHED',
  DO_NOT_CONTACT: 'DO_NOT_CONTACT',
  CONVERTED: 'CONVERTED'
};

exports.SequenceActivityLogEventTypeEnum = exports.$Enums.SequenceActivityLogEventTypeEnum = {
  EMAIL_SENT_FOR_SEQUENCE_STEP: 'EMAIL_SENT_FOR_SEQUENCE_STEP',
  EMAIL_OPENED: 'EMAIL_OPENED',
  EMAIL_CLICKED: 'EMAIL_CLICKED',
  EMAIL_REPLIED: 'EMAIL_REPLIED',
  EMAIL_BOUNCED: 'EMAIL_BOUNCED',
  EMAIL_UNSUBSCRIBED: 'EMAIL_UNSUBSCRIBED'
};

exports.ApprovalWorkflowStatusEnum = exports.$Enums.ApprovalWorkflowStatusEnum = {
  APPROVED: 'APPROVED',
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  REJECTED: 'REJECTED',
  CANCELED: 'CANCELED'
};

exports.ApprovalStrictnessLevelEnum = exports.$Enums.ApprovalStrictnessLevelEnum = {
  ALL: 'ALL',
  AT_LEAST_ONE: 'AT_LEAST_ONE'
};

exports.ApprovalWorkflowTypeEnum = exports.$Enums.ApprovalWorkflowTypeEnum = {
  JOB_REQUISITION: 'JOB_REQUISITION',
  OPENING: 'OPENING',
  OFFER: 'OFFER'
};

exports.CustomJobRequisitionFieldTypeEnum = exports.$Enums.CustomJobRequisitionFieldTypeEnum = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  SELECT: 'SELECT',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
  DATE: 'DATE',
  FILES: 'FILES',
  PERSON: 'PERSON',
  CHECKBOX: 'CHECKBOX',
  URL: 'URL',
  CURRENCY: 'CURRENCY',
  RADIO: 'RADIO',
  RANGE: 'RANGE',
  DATE_RANGE: 'DATE_RANGE'
};

exports.NotificationEventTypeEnum = exports.$Enums.NotificationEventTypeEnum = {
  CANDIDATE_NEW_APPLICANT: 'CANDIDATE_NEW_APPLICANT',
  CANDIDATE_HIRED: 'CANDIDATE_HIRED',
  CANDIDATE_START_DATE_SET: 'CANDIDATE_START_DATE_SET',
  CANDIDATE_ADDED_BY_TEAM_MEMBER: 'CANDIDATE_ADDED_BY_TEAM_MEMBER',
  CANDIDATE_STATUS_UPDATED: 'CANDIDATE_STATUS_UPDATED',
  CANDIDATE_NEW_MESSAGE: 'CANDIDATE_NEW_MESSAGE',
  CANDIDATE_OFFER_SENT: 'CANDIDATE_OFFER_SENT',
  CANDIDATE_OFFER_RESPONSE: 'CANDIDATE_OFFER_RESPONSE',
  CANDIDATE_REFERRAL_SUBMITTED: 'CANDIDATE_REFERRAL_SUBMITTED',
  CANDIDATE_BACKGROUND_CHECK_COMPLETED: 'CANDIDATE_BACKGROUND_CHECK_COMPLETED',
  CANDIDATE_FOLLOWUP_NEEDED: 'CANDIDATE_FOLLOWUP_NEEDED',
  CANDIDATE_INTERVIEW_RESCHEDULE: 'CANDIDATE_INTERVIEW_RESCHEDULE',
  CANDIDATE_OFFER_PENDING_APPROVAL: 'CANDIDATE_OFFER_PENDING_APPROVAL',
  CANDIDATE_OFFER_APPROVED: 'CANDIDATE_OFFER_APPROVED',
  CANDIDATE_REJECTION_QUEUED: 'CANDIDATE_REJECTION_QUEUED',
  CANDIDATE_REJECTED: 'CANDIDATE_REJECTED',
  CANDIDATE_REJECTION_UNDONE: 'CANDIDATE_REJECTION_UNDONE',
  JOB_SCORECARD_ASSIGNED: 'JOB_SCORECARD_ASSIGNED',
  JOB_AD_EXPIRING: 'JOB_AD_EXPIRING',
  JOB_PIPELINE_CHANGED: 'JOB_PIPELINE_CHANGED',
  JOB_SELF_SCHEDULER_BOOKED: 'JOB_SELF_SCHEDULER_BOOKED',
  JOB_INTERVIEW_ASSIGNED: 'JOB_INTERVIEW_ASSIGNED',
  JOB_CLOSED: 'JOB_CLOSED',
  JOB_OPENED: 'JOB_OPENED',
  JOB_INTERVIEW_TODAY: 'JOB_INTERVIEW_TODAY',
  JOB_SCORECARD_SUBMITTED: 'JOB_SCORECARD_SUBMITTED',
  JOB_REQUIREMENTS_CHANGED: 'JOB_REQUIREMENTS_CHANGED',
  JOB_NEW_MATCHES: 'JOB_NEW_MATCHES',
  JOB_ASSIGNED_TO_HIRING_TEAM: 'JOB_ASSIGNED_TO_HIRING_TEAM',
  JOB_ASSIGNED_PRIMARY_RECRUITER: 'JOB_ASSIGNED_PRIMARY_RECRUITER',
  JOB_ASSIGNED_HIRING_MANAGER: 'JOB_ASSIGNED_HIRING_MANAGER',
  JOB_CANDIDATE_ADVANCED: 'JOB_CANDIDATE_ADVANCED',
  JOB_CANDIDATES_NEED_REVIEW: 'JOB_CANDIDATES_NEED_REVIEW'
};

exports.InterviewStageTypeEnum = exports.$Enums.InterviewStageTypeEnum = {
  REVIEW: 'REVIEW',
  PHONE_SCREEN: 'PHONE_SCREEN',
  INTERVIEW: 'INTERVIEW',
  ASSESSMENT: 'ASSESSMENT',
  REFERENCE_CHECK: 'REFERENCE_CHECK',
  BACKGROUND_CHECK: 'BACKGROUND_CHECK'
};

exports.InterviewTypeEnum = exports.$Enums.InterviewTypeEnum = {
  REMOTE: 'REMOTE',
  IN__PERSON: 'IN__PERSON'
};

exports.AvailabilityRequestStatusEnum = exports.$Enums.AvailabilityRequestStatusEnum = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
  EXPIRED: 'EXPIRED'
};

exports.Prisma.ModelName = {
  Achievement: 'Achievement',
  ActivityLog: 'ActivityLog',
  Address: 'Address',
  ApplicantNotes: 'ApplicantNotes',
  ApplicationRejection: 'ApplicationRejection',
  ApplicationSnapshot: 'ApplicationSnapshot',
  ArchivedChat: 'ArchivedChat',
  BookmarkedJob: 'BookmarkedJob',
  CandidateApplication: 'CandidateApplication',
  CandidateApplicationNote: 'CandidateApplicationNote',
  CandidateApplicationRating: 'CandidateApplicationRating',
  CandidateInterview: 'CandidateInterview',
  CandidateInterviewCompanyUser: 'CandidateInterviewCompanyUser',
  CandidateMedalistDesignation: 'CandidateMedalistDesignation',
  CandidateMessage: 'CandidateMessage',
  CandidateProfile: 'CandidateProfile',
  CandidateProfileLocation: 'CandidateProfileLocation',
  CandidateProfileNote: 'CandidateProfileNote',
  CandidateScorecard: 'CandidateScorecard',
  CandidateScorecardAnswers: 'CandidateScorecardAnswers',
  CandidateSource: 'CandidateSource',
  CandidateSourceName: 'CandidateSourceName',
  CustomSourceCategory: 'CustomSourceCategory',
  CertificateOrLicense: 'CertificateOrLicense',
  Chat: 'Chat',
  ChatParticipant: 'ChatParticipant',
  ChatC2J: 'ChatC2J',
  Company: 'Company',
  CompanyDepartment: 'CompanyDepartment',
  CompanyInfo: 'CompanyInfo',
  CompanyOffice: 'CompanyOffice',
  CompanyUser: 'CompanyUser',
  ContactInfo: 'ContactInfo',
  DemographicInfo: 'DemographicInfo',
  Education: 'Education',
  EmailVerification: 'EmailVerification',
  CalendarEvent: 'CalendarEvent',
  EventAttachment: 'EventAttachment',
  EventJob: 'EventJob',
  Experience: 'Experience',
  HiringTeamMember: 'HiringTeamMember',
  CandidateCollaborator: 'CandidateCollaborator',
  StageCollaborator: 'StageCollaborator',
  JobInvite: 'JobInvite',
  JobListing: 'JobListing',
  JobListingJobPipeline: 'JobListingJobPipeline',
  JobListingScreeningQuestion: 'JobListingScreeningQuestion',
  JobOpening: 'JobOpening',
  JobPipeline: 'JobPipeline',
  JobSeekerHeader: 'JobSeekerHeader',
  JobSeekerInfo: 'JobSeekerInfo',
  JobSeekerSkill: 'JobSeekerSkill',
  JobSeekerSkillExperience: 'JobSeekerSkillExperience',
  CalendarSettings: 'CalendarSettings',
  ConnectedEmailSettings: 'ConnectedEmailSettings',
  EmailConnection: 'EmailConnection',
  EmailRecord: 'EmailRecord',
  EmailThread: 'EmailThread',
  ConnectedEmail: 'ConnectedEmail',
  ConnectedEmailTrack: 'ConnectedEmailTrack',
  CandidateIncomingEmail: 'CandidateIncomingEmail',
  Calendar: 'Calendar',
  Permission: 'Permission',
  ProfileDetails: 'ProfileDetails',
  CompanyProvidedEmail: 'CompanyProvidedEmail',
  RejectCandidateQuestion: 'RejectCandidateQuestion',
  RejectCandidateQuestionRating: 'RejectCandidateQuestionRating',
  Requisition: 'Requisition',
  RequisitionExtId: 'RequisitionExtId',
  RequisitionJobDescription: 'RequisitionJobDescription',
  RequisitionSkill: 'RequisitionSkill',
  Role: 'Role',
  RolePermissions: 'RolePermissions',
  ScalisUser: 'ScalisUser',
  SchedulerLinkInvite: 'SchedulerLinkInvite',
  SchedulerLinkSettings: 'SchedulerLinkSettings',
  ScorecardTemplate: 'ScorecardTemplate',
  ScorecardTemplateQuestion: 'ScorecardTemplateQuestion',
  ScorecardTemplateSection: 'ScorecardTemplateSection',
  ScreeningQuestion: 'ScreeningQuestion',
  ScreeningQuestionAnswer: 'ScreeningQuestionAnswer',
  ApplicationForm: 'ApplicationForm',
  ApplicationFormScreeningQuestion: 'ApplicationFormScreeningQuestion',
  Skill: 'Skill',
  StageSettings: 'StageSettings',
  InterviewTeam: 'InterviewTeam',
  TemplateJobDescription: 'TemplateJobDescription',
  TemplateMessage: 'TemplateMessage',
  TemplateMilestone: 'TemplateMilestone',
  TemplatePipeline: 'TemplatePipeline',
  TemplateStage: 'TemplateStage',
  CandidateMerge: 'CandidateMerge',
  EnrichedLocation: 'EnrichedLocation',
  EnrichedPhoneNumber: 'EnrichedPhoneNumber',
  EnrichedEmail: 'EnrichedEmail',
  UploadedCandidate: 'UploadedCandidate',
  UploadedCandidateAchievement: 'UploadedCandidateAchievement',
  UploadedCandidateCertificateOrLicense: 'UploadedCandidateCertificateOrLicense',
  UploadedCandidateEducation: 'UploadedCandidateEducation',
  UploadedCandidateExperience: 'UploadedCandidateExperience',
  UploadedCandidateJobSeekerSkill: 'UploadedCandidateJobSeekerSkill',
  UploadedCandidateSkill: 'UploadedCandidateSkill',
  UploadedCandidateVolunteerWork: 'UploadedCandidateVolunteerWork',
  UploadedCandidateWebsiteOrSocialMedia: 'UploadedCandidateWebsiteOrSocialMedia',
  UploadedDocument: 'UploadedDocument',
  UploadedDocumentCandidateApplication: 'UploadedDocumentCandidateApplication',
  UploadedDocumentCandidateProfile: 'UploadedDocumentCandidateProfile',
  ScalisUserUploadedDocument: 'ScalisUserUploadedDocument',
  UserInvitation: 'UserInvitation',
  UserNote: 'UserNote',
  UserRoles: 'UserRoles',
  VolunteerWork: 'VolunteerWork',
  WebsiteOrSocialMedia: 'WebsiteOrSocialMedia',
  ExternalJobApplication: 'ExternalJobApplication',
  JobAdCampaign: 'JobAdCampaign',
  Order: 'Order',
  AiFeatureUsage: 'AiFeatureUsage',
  UserSubscription: 'UserSubscription',
  CandidateOffer: 'CandidateOffer',
  CandidateOfferVersion: 'CandidateOfferVersion',
  CandidateOfferVersionSignature: 'CandidateOfferVersionSignature',
  CandidateOfferCustomField: 'CandidateOfferCustomField',
  CandidateOfferFile: 'CandidateOfferFile',
  DefaultToken: 'DefaultToken',
  OfferDocumentTemplate: 'OfferDocumentTemplate',
  OfferTemplateCondition: 'OfferTemplateCondition',
  OfferSectionTemplate: 'OfferSectionTemplate',
  OfferDocumentTemplateSection: 'OfferDocumentTemplateSection',
  OfferCustomField: 'OfferCustomField',
  TokenTestResult: 'TokenTestResult',
  CandidateOfferRejection: 'CandidateOfferRejection',
  CandidateApplicationStatus: 'CandidateApplicationStatus',
  CoreReport: 'CoreReport',
  ScheduledReport: 'ScheduledReport',
  FavoriteCoreReport: 'FavoriteCoreReport',
  SharedCoreReport: 'SharedCoreReport',
  CoreReportFilter: 'CoreReportFilter',
  JobListingVectors: 'JobListingVectors',
  JobListingScores: 'JobListingScores',
  ScalisApplicationParameter: 'ScalisApplicationParameter',
  GlobalListingSetup: 'GlobalListingSetup',
  CompanyUserGroup: 'CompanyUserGroup',
  CompanyUserGroupCompanyUser: 'CompanyUserGroupCompanyUser',
  CompanyUserGroupCompanyOffice: 'CompanyUserGroupCompanyOffice',
  CompanyUserGroupCompanyDepartment: 'CompanyUserGroupCompanyDepartment',
  CompanySavedView: 'CompanySavedView',
  RequisitionTalentPoolCompanySavedView: 'RequisitionTalentPoolCompanySavedView',
  TalentPool: 'TalentPool',
  CompanyUserView: 'CompanyUserView',
  TalentPoolCandidateProfile: 'TalentPoolCandidateProfile',
  CandidateFilter: 'CandidateFilter',
  JobSearchPreference: 'JobSearchPreference',
  JobListingRecommendation: 'JobListingRecommendation',
  ScalisUserRecommendation: 'ScalisUserRecommendation',
  ApprovalWorkflow: 'ApprovalWorkflow',
  CandidateLabel: 'CandidateLabel',
  CandidateLabelCandidateProfile: 'CandidateLabelCandidateProfile',
  TalentPoolTag: 'TalentPoolTag',
  TalentPoolTagTalentPool: 'TalentPoolTagTalentPool',
  TalentPoolAssociatedRequisition: 'TalentPoolAssociatedRequisition',
  TalentPoolContributor: 'TalentPoolContributor',
  FavoriteTalentPool: 'FavoriteTalentPool',
  TalentPoolProspectStatus: 'TalentPoolProspectStatus',
  CustomApplicationStatus: 'CustomApplicationStatus',
  CustomCandidateProfileField: 'CustomCandidateProfileField',
  CustomCandidateProfileFieldValue: 'CustomCandidateProfileFieldValue',
  CustomCandidateApplicationField: 'CustomCandidateApplicationField',
  CustomCandidateApplicationFieldRequisition: 'CustomCandidateApplicationFieldRequisition',
  CustomCandidateApplicationFieldValue: 'CustomCandidateApplicationFieldValue',
  Sequence: 'Sequence',
  FavoriteSequence: 'FavoriteSequence',
  SequenceSetting: 'SequenceSetting',
  SequenceScheduleSetting: 'SequenceScheduleSetting',
  SequenceStep: 'SequenceStep',
  SequenceAssociatedRequisition: 'SequenceAssociatedRequisition',
  SequenceAssociatedTalentPool: 'SequenceAssociatedTalentPool',
  SequenceCandidate: 'SequenceCandidate',
  SequenceActivityLog: 'SequenceActivityLog',
  ApprovalWorkflowVersion: 'ApprovalWorkflowVersion',
  ApprovalWorkflowVersionStep: 'ApprovalWorkflowVersionStep',
  ApprovalWorkflowVersionTemplateMapping: 'ApprovalWorkflowVersionTemplateMapping',
  ApprovalReviewerStatus: 'ApprovalReviewerStatus',
  TemplateApprovalWorkflowStep: 'TemplateApprovalWorkflowStep',
  TemplateApprovalReviewer: 'TemplateApprovalReviewer',
  TemplateApprovalWorkflow: 'TemplateApprovalWorkflow',
  CompanyApprovalSetting: 'CompanyApprovalSetting',
  ApprovalWorkflowEntityMapping: 'ApprovalWorkflowEntityMapping',
  CustomJobRequisitionField: 'CustomJobRequisitionField',
  CustomJobRequisitionFieldValue: 'CustomJobRequisitionFieldValue',
  CompanyCustomFieldToken: 'CompanyCustomFieldToken',
  NotificationSetting: 'NotificationSetting',
  CompanyGlobal: 'CompanyGlobal',
  CompanyTags: 'CompanyTags',
  IntegrationsNylasNotetaker: 'IntegrationsNylasNotetaker',
  InterviewerPool: 'InterviewerPool',
  InterviewerPoolMember: 'InterviewerPoolMember',
  InterviewerPoolDepartment: 'InterviewerPoolDepartment',
  InterviewerPoolOffice: 'InterviewerPoolOffice',
  InterviewerPoolJob: 'InterviewerPoolJob',
  InterviewerPoolSkill: 'InterviewerPoolSkill',
  InterviewPoolMemberSkill: 'InterviewPoolMemberSkill',
  InterviewTemplate: 'InterviewTemplate',
  InterviewTemplateLoop: 'InterviewTemplateLoop',
  CandidateInterviewLoop: 'CandidateInterviewLoop',
  CandidateAvailabilityRequest: 'CandidateAvailabilityRequest',
  CandidateAvailabilitySlot: 'CandidateAvailabilitySlot'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
